export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Color: string;
  DateTime: string;
  Decimal: string;
  HTML: string;
  ISO8601DateTime: any;
  JSON: any;
  URL: string;
  UnsignedInt64: string;
};

export type ApiVersion = {
  __typename?: 'ApiVersion';
  displayName: Scalars['String'];
  handle: Scalars['String'];
  supported: Scalars['Boolean'];
};

export type ApplePayWalletContentInput = {
  billingAddress: MailingAddressInput;
  data: Scalars['String'];
  header: ApplePayWalletHeaderInput;
  lastDigits?: InputMaybe<Scalars['String']>;
  signature: Scalars['String'];
  version: Scalars['String'];
};

export type ApplePayWalletHeaderInput = {
  applicationData?: InputMaybe<Scalars['String']>;
  ephemeralPublicKey: Scalars['String'];
  publicKeyHash: Scalars['String'];
  transactionId: Scalars['String'];
};

export type AppliedGiftCard = Node & {
  __typename?: 'AppliedGiftCard';
  amountUsed: MoneyV2;
  /** @deprecated Use `amountUsed` instead. */
  amountUsedV2: MoneyV2;
  balance: MoneyV2;
  /** @deprecated Use `balance` instead. */
  balanceV2: MoneyV2;
  id: Scalars['ID'];
  lastCharacters: Scalars['String'];
  presentmentAmountUsed: MoneyV2;
};

export type Article = HasMetafields & Node & OnlineStorePublishable & Trackable & {
  __typename?: 'Article';
  /** @deprecated Use `authorV2` instead. */
  author: ArticleAuthor;
  authorV2?: Maybe<ArticleAuthor>;
  blog: Blog;
  comments: CommentConnection;
  content: Scalars['String'];
  contentHtml: Scalars['HTML'];
  excerpt?: Maybe<Scalars['String']>;
  excerptHtml?: Maybe<Scalars['HTML']>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  publishedAt: Scalars['DateTime'];
  seo?: Maybe<Seo>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  trackingParameters?: Maybe<Scalars['String']>;
};


export type ArticleCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type ArticleContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


export type ArticleExcerptArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


export type ArticleMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type ArticleMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  bio?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
};

export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  edges: Array<ArticleEdge>;
  nodes: Array<Article>;
  pageInfo: PageInfo;
};

export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  cursor: Scalars['String'];
  node: Article;
};

export type ArticleSortKeys =
  | 'AUTHOR'
  | 'BLOG_TITLE'
  | 'ID'
  | 'PUBLISHED_AT'
  | 'RELEVANCE'
  | 'TITLE'
  | 'UPDATED_AT';

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type AttributeInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AutomaticDiscountApplication = DiscountApplication & {
  __typename?: 'AutomaticDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
  value: PricingValue;
};

export type BaseCartDiscountApplication = {
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  totalAllocatedAmount: MoneyV2;
  value: PricingValue;
};

export type BaseCartLine = {
  attribute?: Maybe<Attribute>;
  attributes: Array<Attribute>;
  cost: CartLineCost;
  discountAllocations: Array<CartDiscountAllocation>;
  /** @deprecated Use `cost` instead. */
  estimatedCost: CartLineEstimatedCost;
  id: Scalars['ID'];
  merchandise: Merchandise;
  quantity: Scalars['Int'];
  sellingPlanAllocation?: Maybe<SellingPlanAllocation>;
  viewKey?: Maybe<Scalars['String']>;
};


export type BaseCartLineAttributeArgs = {
  key: Scalars['String'];
};


export type BaseCartLineDiscountAllocationsArgs = {
  lineLevelOnly?: InputMaybe<Scalars['Boolean']>;
};

export type BaseCartLineConnection = {
  __typename?: 'BaseCartLineConnection';
  edges: Array<BaseCartLineEdge>;
  nodes: Array<BaseCartLine>;
  pageInfo: PageInfo;
};

export type BaseCartLineEdge = {
  __typename?: 'BaseCartLineEdge';
  cursor: Scalars['String'];
  node: BaseCartLine;
};

export type Blog = HasMetafields & Node & OnlineStorePublishable & {
  __typename?: 'Blog';
  articleByHandle?: Maybe<Article>;
  articles: ArticleConnection;
  authors: Array<ArticleAuthor>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  seo?: Maybe<Seo>;
  title: Scalars['String'];
};


export type BlogArticleByHandleArgs = {
  handle: Scalars['String'];
};


export type BlogArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ArticleSortKeys>;
};


export type BlogMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type BlogMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type BlogConnection = {
  __typename?: 'BlogConnection';
  edges: Array<BlogEdge>;
  nodes: Array<Blog>;
  pageInfo: PageInfo;
};

export type BlogEdge = {
  __typename?: 'BlogEdge';
  cursor: Scalars['String'];
  node: Blog;
};

export type BlogSortKeys =
  | 'HANDLE'
  | 'ID'
  | 'RELEVANCE'
  | 'TITLE';

export type Brand = {
  __typename?: 'Brand';
  colors: BrandColors;
  coverImage?: Maybe<MediaImage>;
  logo?: Maybe<MediaImage>;
  shortDescription?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  squareLogo?: Maybe<MediaImage>;
};

export type BrandColorGroup = {
  __typename?: 'BrandColorGroup';
  background?: Maybe<Scalars['Color']>;
  foreground?: Maybe<Scalars['Color']>;
};

export type BrandColors = {
  __typename?: 'BrandColors';
  primary: Array<BrandColorGroup>;
  secondary: Array<BrandColorGroup>;
};

export type BuyerInput = {
  companyLocationId?: InputMaybe<Scalars['ID']>;
  customerAccessToken: Scalars['String'];
};

export type CardBrand =
  | 'AMERICAN_EXPRESS'
  | 'DINERS_CLUB'
  | 'DISCOVER'
  | 'JCB'
  | 'MASTERCARD'
  | 'VISA';

export type Cart = HasMetafields & Node & {
  __typename?: 'Cart';
  appliedGiftCards: Array<AppliedGiftCard>;
  attribute?: Maybe<Attribute>;
  attributes: Array<Attribute>;
  buyerIdentity: CartBuyerIdentity;
  checkoutUrl: Scalars['URL'];
  cost: CartCost;
  createdAt: Scalars['DateTime'];
  delivery: CartDelivery;
  deliveryGroups: CartDeliveryGroupConnection;
  /** @deprecated Use `cart.lines[].discountAllocations(lineLevelOnly: false)` and `cart.deliveryGroups[].discountAllocations` instead. */
  discountAllocations: Array<CartDiscountAllocation>;
  discountApplications: Array<BaseCartDiscountApplication>;
  discountCodes: Array<CartDiscountCode>;
  /** @deprecated Use `cost` instead. */
  estimatedCost: CartEstimatedCost;
  id: Scalars['ID'];
  lines: BaseCartLineConnection;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  note?: Maybe<Scalars['String']>;
  totalQuantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type CartAttributeArgs = {
  key: Scalars['String'];
};


export type CartDeliveryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  withCarrierRates?: InputMaybe<Scalars['Boolean']>;
};


export type CartLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type CartMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type CartMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type CartAddress = CartDeliveryAddress;

export type CartAddressInput = {
  copyFromCustomerAddressId?: InputMaybe<Scalars['ID']>;
  deliveryAddress?: InputMaybe<CartDeliveryAddressInput>;
};

export type CartAttributesUpdatePayload = {
  __typename?: 'CartAttributesUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartAutomaticDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartAutomaticDiscountAllocation';
  /** @deprecated Use `sourceDiscountApplication` instead. */
  discountApplication: CartDiscountApplication;
  discountedAmount: MoneyV2;
  sourceDiscountApplication: BaseCartDiscountApplication;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
};

export type CartAutomaticDiscountApplication = BaseCartDiscountApplication & {
  __typename?: 'CartAutomaticDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
  totalAllocatedAmount: MoneyV2;
  value: PricingValue;
};

export type CartBillingAddressUpdatePayload = {
  __typename?: 'CartBillingAddressUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartBuyerIdentity = {
  __typename?: 'CartBuyerIdentity';
  countryCode?: Maybe<CountryCode>;
  customer?: Maybe<Customer>;
  /** @deprecated Use `cart.delivery` instead. */
  deliveryAddressPreferences: Array<DeliveryAddress>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferences?: Maybe<CartPreferences>;
  purchasingCompany?: Maybe<PurchasingCompany>;
};

export type CartBuyerIdentityInput = {
  companyLocationId?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<CountryCode>;
  customerAccessToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<CartPreferencesInput>;
};

export type CartBuyerIdentityUpdatePayload = {
  __typename?: 'CartBuyerIdentityUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartCardSource =
  | 'SAVED_CREDIT_CARD';

export type CartClonePayload = {
  __typename?: 'CartClonePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartCodeDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartCodeDiscountAllocation';
  code: Scalars['String'];
  /** @deprecated Use `sourceDiscountApplication` instead. */
  discountApplication: CartDiscountApplication;
  discountedAmount: MoneyV2;
  sourceDiscountApplication: BaseCartDiscountApplication;
  targetType: DiscountApplicationTargetType;
};

export type CartCodeDiscountApplication = BaseCartDiscountApplication & {
  __typename?: 'CartCodeDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  code: Scalars['String'];
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  totalAllocatedAmount: MoneyV2;
  value: PricingValue;
};

export type CartCompletionAction = CompletePaymentChallenge;

export type CartCompletionActionRequired = {
  __typename?: 'CartCompletionActionRequired';
  action?: Maybe<CartCompletionAction>;
  id: Scalars['String'];
};

export type CartCompletionAttemptResult = CartCompletionActionRequired | CartCompletionFailed | CartCompletionProcessing | CartCompletionSuccess;

export type CartCompletionFailed = {
  __typename?: 'CartCompletionFailed';
  errors: Array<CompletionError>;
  id: Scalars['String'];
};

export type CartCompletionProcessing = {
  __typename?: 'CartCompletionProcessing';
  id: Scalars['String'];
  pollDelay: Scalars['Int'];
};

export type CartCompletionSuccess = {
  __typename?: 'CartCompletionSuccess';
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  orderId: Scalars['ID'];
  orderUrl: Scalars['URL'];
};

export type CartCost = {
  __typename?: 'CartCost';
  checkoutChargeAmount: MoneyV2;
  subtotalAmount: MoneyV2;
  subtotalAmountEstimated: Scalars['Boolean'];
  totalAmount: MoneyV2;
  totalAmountEstimated: Scalars['Boolean'];
  /**
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalDutyAmount?: Maybe<MoneyV2>;
  /**
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalDutyAmountEstimated: Scalars['Boolean'];
  /**
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalTaxAmount?: Maybe<MoneyV2>;
  /**
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalTaxAmountEstimated: Scalars['Boolean'];
};

export type CartCreatePayload = {
  __typename?: 'CartCreatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartCustomDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartCustomDiscountAllocation';
  /** @deprecated Use `sourceDiscountApplication` instead. */
  discountApplication: CartDiscountApplication;
  discountedAmount: MoneyV2;
  sourceDiscountApplication: BaseCartDiscountApplication;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
};

export type CartCustomDiscountApplication = BaseCartDiscountApplication & {
  __typename?: 'CartCustomDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
  totalAllocatedAmount: MoneyV2;
  value: PricingValue;
};

export type CartDelivery = {
  __typename?: 'CartDelivery';
  addresses: Array<CartSelectableAddress>;
};


export type CartDeliveryAddressesArgs = {
  selected?: InputMaybe<Scalars['Boolean']>;
};

export type CartDeliveryAddress = {
  __typename?: 'CartDeliveryAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formatted: Array<Scalars['String']>;
  formattedArea?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type CartDeliveryAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']>;
  withName?: InputMaybe<Scalars['Boolean']>;
};

export type CartDeliveryAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCode>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  provinceCode?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CartDeliveryAddressesAddPayload = {
  __typename?: 'CartDeliveryAddressesAddPayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartDeliveryAddressesRemovePayload = {
  __typename?: 'CartDeliveryAddressesRemovePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartDeliveryAddressesReplacePayload = {
  __typename?: 'CartDeliveryAddressesReplacePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartDeliveryAddressesUpdatePayload = {
  __typename?: 'CartDeliveryAddressesUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartDeliveryCoordinatesPreference = {
  __typename?: 'CartDeliveryCoordinatesPreference';
  countryCode: CountryCode;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CartDeliveryCoordinatesPreferenceInput = {
  countryCode: CountryCode;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CartDeliveryGroup = {
  __typename?: 'CartDeliveryGroup';
  cartLines: BaseCartLineConnection;
  deliveryAddress: MailingAddress;
  deliveryOptions: Array<CartDeliveryOption>;
  discountAllocations: Array<CartDiscountAllocation>;
  groupType: CartDeliveryGroupType;
  id: Scalars['ID'];
  selectedDeliveryOption?: Maybe<CartDeliveryOption>;
};


export type CartDeliveryGroupCartLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type CartDeliveryGroupConnection = {
  __typename?: 'CartDeliveryGroupConnection';
  edges: Array<CartDeliveryGroupEdge>;
  nodes: Array<CartDeliveryGroup>;
  pageInfo: PageInfo;
};

export type CartDeliveryGroupEdge = {
  __typename?: 'CartDeliveryGroupEdge';
  cursor: Scalars['String'];
  node: CartDeliveryGroup;
};

export type CartDeliveryGroupType =
  | 'ONE_TIME_PURCHASE'
  | 'SUBSCRIPTION';

export type CartDeliveryInput = {
  addresses?: InputMaybe<Array<CartSelectableAddressInput>>;
};

export type CartDeliveryOption = {
  __typename?: 'CartDeliveryOption';
  code?: Maybe<Scalars['String']>;
  deliveryMethodType: DeliveryMethodType;
  description?: Maybe<Scalars['String']>;
  estimatedCost: MoneyV2;
  handle: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type CartDeliveryPreference = {
  __typename?: 'CartDeliveryPreference';
  coordinates?: Maybe<CartDeliveryCoordinatesPreference>;
  deliveryMethod: Array<PreferenceDeliveryMethodType>;
  pickupHandle: Array<Scalars['String']>;
};

export type CartDeliveryPreferenceInput = {
  coordinates?: InputMaybe<CartDeliveryCoordinatesPreferenceInput>;
  deliveryMethod?: InputMaybe<Array<PreferenceDeliveryMethodType>>;
  pickupHandle?: InputMaybe<Array<Scalars['String']>>;
};

export type CartDirectPaymentMethodInput = {
  acceptedSubscriptionTerms?: InputMaybe<Scalars['Boolean']>;
  billingAddress: MailingAddressInput;
  cardSource?: InputMaybe<CartCardSource>;
  sessionId: Scalars['String'];
};

export type CartDiscountAllocation = {
  /** @deprecated Use `sourceDiscountApplication` instead. */
  discountApplication: CartDiscountApplication;
  discountedAmount: MoneyV2;
  sourceDiscountApplication: BaseCartDiscountApplication;
  targetType: DiscountApplicationTargetType;
};

export type CartDiscountApplication = {
  __typename?: 'CartDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  value: PricingValue;
};

export type CartDiscountCode = {
  __typename?: 'CartDiscountCode';
  applicable: Scalars['Boolean'];
  code: Scalars['String'];
};

export type CartDiscountCodesUpdatePayload = {
  __typename?: 'CartDiscountCodesUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartErrorCode =
  | 'ADDRESS_FIELD_CONTAINS_EMOJIS'
  | 'ADDRESS_FIELD_CONTAINS_HTML_TAGS'
  | 'ADDRESS_FIELD_CONTAINS_URL'
  | 'ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN'
  | 'ADDRESS_FIELD_IS_REQUIRED'
  | 'ADDRESS_FIELD_IS_TOO_LONG'
  | 'BUNDLES_AND_ADDONS_CANNOT_BE_MIXED'
  | 'BUYER_CANNOT_PURCHASE_FOR_COMPANY_LOCATION'
  | 'CART_TOO_LARGE'
  | 'GIFT_CARD_RECIPIENT_INVALID'
  | 'INVALID'
  | 'INVALID_COMPANY_LOCATION'
  | 'INVALID_DELIVERY_ADDRESS_ID'
  | 'INVALID_DELIVERY_GROUP'
  | 'INVALID_DELIVERY_OPTION'
  | 'INVALID_INCREMENT'
  | 'INVALID_MERCHANDISE_LINE'
  | 'INVALID_METAFIELDS'
  | 'INVALID_PAYMENT'
  | 'INVALID_PAYMENT_DEFERRED_PAYMENT_REQUIRED'
  | 'INVALID_PAYMENT_EMPTY_CART'
  | 'INVALID_ZIP_CODE_FOR_COUNTRY'
  | 'INVALID_ZIP_CODE_FOR_PROVINCE'
  | 'LESS_THAN'
  | 'MAXIMUM_EXCEEDED'
  | 'MERCHANDISE_LINE_TRANSFORMERS_RUN_ERROR'
  | 'MERCHANDISE_NOT_APPLICABLE'
  | 'MINIMUM_NOT_MET'
  | 'MISSING_CUSTOMER_ACCESS_TOKEN'
  | 'MISSING_DISCOUNT_CODE'
  | 'MISSING_NOTE'
  | 'NOTE_TOO_LONG'
  | 'ONLY_ONE_DELIVERY_ADDRESS_CAN_BE_SELECTED'
  | 'PARENT_LINE_INVALID_REFERENCE'
  | 'PARENT_LINE_NESTING_TOO_DEEP'
  | 'PARENT_LINE_NOT_FOUND'
  | 'PARENT_LINE_OPERATION_BLOCKED'
  | 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED'
  | 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED'
  | 'PAYMENTS_CREDIT_CARD_GENERIC'
  | 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION'
  | 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID'
  | 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT'
  | 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK'
  | 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE'
  | 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED'
  | 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR'
  | 'PAYMENT_METHOD_NOT_APPLICABLE'
  | 'PAYMENT_METHOD_NOT_SUPPORTED'
  | 'PENDING_DELIVERY_GROUPS'
  | 'PROVINCE_NOT_FOUND'
  | 'SELLING_PLAN_NOT_APPLICABLE'
  | 'SERVICE_UNAVAILABLE'
  | 'TOO_MANY_DELIVERY_ADDRESSES'
  | 'UNSPECIFIED_ADDRESS_ERROR'
  | 'VALIDATION_CUSTOM'
  | 'VARIANT_REQUIRES_SELLING_PLAN'
  | 'ZIP_CODE_NOT_SUPPORTED';

export type CartEstimatedCost = {
  __typename?: 'CartEstimatedCost';
  checkoutChargeAmount: MoneyV2;
  subtotalAmount: MoneyV2;
  totalAmount: MoneyV2;
  totalDutyAmount?: Maybe<MoneyV2>;
  totalTaxAmount?: Maybe<MoneyV2>;
};

export type CartFreePaymentMethodInput = {
  billingAddress: MailingAddressInput;
};

export type CartGiftCardCodesAddPayload = {
  __typename?: 'CartGiftCardCodesAddPayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartGiftCardCodesRemovePayload = {
  __typename?: 'CartGiftCardCodesRemovePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartGiftCardCodesUpdatePayload = {
  __typename?: 'CartGiftCardCodesUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  buyerIdentity?: InputMaybe<CartBuyerIdentityInput>;
  delivery?: InputMaybe<CartDeliveryInput>;
  discountCodes?: InputMaybe<Array<Scalars['String']>>;
  giftCardCodes?: InputMaybe<Array<Scalars['String']>>;
  lines?: InputMaybe<Array<CartLineInput>>;
  metafields?: InputMaybe<Array<CartInputMetafieldInput>>;
  note?: InputMaybe<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
};

export type CartInputMetafieldInput = {
  key: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type CartLine = BaseCartLine & Node & {
  __typename?: 'CartLine';
  attribute?: Maybe<Attribute>;
  attributes: Array<Attribute>;
  cost: CartLineCost;
  discountAllocations: Array<CartDiscountAllocation>;
  /** @deprecated Use `cost` instead. */
  estimatedCost: CartLineEstimatedCost;
  id: Scalars['ID'];
  instructions: CartLineInstructions;
  merchandise: Merchandise;
  parentRelationship?: Maybe<CartLineParentRelationship>;
  quantity: Scalars['Int'];
  sellingPlanAllocation?: Maybe<SellingPlanAllocation>;
  viewKey?: Maybe<Scalars['String']>;
};


export type CartLineAttributeArgs = {
  key: Scalars['String'];
};


export type CartLineDiscountAllocationsArgs = {
  lineLevelOnly?: InputMaybe<Scalars['Boolean']>;
};

export type CartLineCost = {
  __typename?: 'CartLineCost';
  amountPerQuantity: MoneyV2;
  compareAtAmountPerQuantity?: Maybe<MoneyV2>;
  subtotalAmount: MoneyV2;
  totalAmount: MoneyV2;
};

export type CartLineEstimatedCost = {
  __typename?: 'CartLineEstimatedCost';
  amount: MoneyV2;
  compareAtAmount?: Maybe<MoneyV2>;
  subtotalAmount: MoneyV2;
  totalAmount: MoneyV2;
};

export type CartLineInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  merchandiseId: Scalars['ID'];
  parent?: InputMaybe<CartLineParentInput>;
  quantity?: InputMaybe<Scalars['Int']>;
  sellingPlanId?: InputMaybe<Scalars['ID']>;
};

export type CartLineInstructions = {
  __typename?: 'CartLineInstructions';
  canRemove: Scalars['Boolean'];
  canUpdateQuantity: Scalars['Boolean'];
};

export type CartLineParentInput = {
  lineId?: InputMaybe<Scalars['ID']>;
  merchandiseId?: InputMaybe<Scalars['ID']>;
};

export type CartLineParentRelationship = {
  __typename?: 'CartLineParentRelationship';
  parent: CartLine;
};

export type CartLineUpdateInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  id?: InputMaybe<Scalars['ID']>;
  merchandiseId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sellingPlanId?: InputMaybe<Scalars['ID']>;
  viewKey?: InputMaybe<Scalars['String']>;
};

export type CartLinesAddPayload = {
  __typename?: 'CartLinesAddPayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartLinesRemovePayload = {
  __typename?: 'CartLinesRemovePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartLinesUpdatePayload = {
  __typename?: 'CartLinesUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartMetafieldDeleteInput = {
  key: Scalars['String'];
  ownerId: Scalars['ID'];
};

export type CartMetafieldDeletePayload = {
  __typename?: 'CartMetafieldDeletePayload';
  deletedId?: Maybe<Scalars['ID']>;
  userErrors: Array<MetafieldDeleteUserError>;
};

export type CartMetafieldsSetInput = {
  key: Scalars['String'];
  ownerId: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type CartMetafieldsSetPayload = {
  __typename?: 'CartMetafieldsSetPayload';
  metafields?: Maybe<Array<Metafield>>;
  userErrors: Array<MetafieldsSetUserError>;
};

export type CartNoteUpdatePayload = {
  __typename?: 'CartNoteUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartOperationError = {
  __typename?: 'CartOperationError';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type CartPaymentInput = {
  amount: MoneyInput;
  directPaymentMethod?: InputMaybe<CartDirectPaymentMethodInput>;
  freePaymentMethod?: InputMaybe<CartFreePaymentMethodInput>;
  sourceIdentifier?: InputMaybe<Scalars['String']>;
  walletPaymentMethod?: InputMaybe<CartWalletPaymentMethodInput>;
};

export type CartPaymentUpdatePayload = {
  __typename?: 'CartPaymentUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartPreferences = {
  __typename?: 'CartPreferences';
  delivery?: Maybe<CartDeliveryPreference>;
  wallet?: Maybe<Array<Scalars['String']>>;
};

export type CartPreferencesInput = {
  delivery?: InputMaybe<CartDeliveryPreferenceInput>;
  wallet?: InputMaybe<Array<Scalars['String']>>;
};

export type CartPrepareForCompletionPayload = {
  __typename?: 'CartPrepareForCompletionPayload';
  result?: Maybe<CartPrepareForCompletionResult>;
  userErrors: Array<CartUserError>;
};

export type CartPrepareForCompletionResult = CartStatusNotReady | CartStatusReady | CartThrottled;

export type CartRemovePersonalDataPayload = {
  __typename?: 'CartRemovePersonalDataPayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartSelectableAddress = {
  __typename?: 'CartSelectableAddress';
  address: CartAddress;
  id: Scalars['ID'];
  oneTimeUse: Scalars['Boolean'];
  selected: Scalars['Boolean'];
};

export type CartSelectableAddressInput = {
  address: CartAddressInput;
  oneTimeUse?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  validationStrategy?: InputMaybe<DeliveryAddressValidationStrategy>;
};

export type CartSelectableAddressUpdateInput = {
  address?: InputMaybe<CartAddressInput>;
  id: Scalars['ID'];
  oneTimeUse?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  validationStrategy?: InputMaybe<DeliveryAddressValidationStrategy>;
};

export type CartSelectedDeliveryOptionInput = {
  deliveryGroupId: Scalars['ID'];
  deliveryOptionHandle: Scalars['String'];
};

export type CartSelectedDeliveryOptionsUpdatePayload = {
  __typename?: 'CartSelectedDeliveryOptionsUpdatePayload';
  cart?: Maybe<Cart>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartStatusNotReady = {
  __typename?: 'CartStatusNotReady';
  cart?: Maybe<Cart>;
  errors: Array<CartOperationError>;
};

export type CartStatusReady = {
  __typename?: 'CartStatusReady';
  cart?: Maybe<Cart>;
};

export type CartSubmitForCompletionPayload = {
  __typename?: 'CartSubmitForCompletionPayload';
  result?: Maybe<CartSubmitForCompletionResult>;
  userErrors: Array<CartUserError>;
};

export type CartSubmitForCompletionResult = SubmitAlreadyAccepted | SubmitFailed | SubmitSuccess | SubmitThrottled;

export type CartThrottled = {
  __typename?: 'CartThrottled';
  cart?: Maybe<Cart>;
  pollAfter: Scalars['DateTime'];
};

export type CartUserError = DisplayableError & {
  __typename?: 'CartUserError';
  code?: Maybe<CartErrorCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type CartWalletPaymentMethodInput = {
  applePayWalletContent?: InputMaybe<ApplePayWalletContentInput>;
  shopPayWalletContent?: InputMaybe<ShopPayWalletContentInput>;
};

export type CartWarning = {
  __typename?: 'CartWarning';
  code: CartWarningCode;
  message: Scalars['String'];
  target: Scalars['ID'];
};

export type CartWarningCode =
  | 'DISCOUNT_CODE_NOT_HONOURED'
  | 'DISCOUNT_CURRENTLY_INACTIVE'
  | 'DISCOUNT_CUSTOMER_NOT_ELIGIBLE'
  | 'DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED'
  | 'DISCOUNT_ELIGIBLE_CUSTOMER_MISSING'
  | 'DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE'
  | 'DISCOUNT_NOT_FOUND'
  | 'DISCOUNT_NO_ENTITLED_LINE_ITEMS'
  | 'DISCOUNT_NO_ENTITLED_SHIPPING_LINES'
  | 'DISCOUNT_PURCHASE_NOT_IN_RANGE'
  | 'DISCOUNT_QUANTITY_NOT_IN_RANGE'
  | 'DISCOUNT_USAGE_LIMIT_REACHED'
  | 'DUPLICATE_DELIVERY_ADDRESS'
  | 'MERCHANDISE_NOT_ENOUGH_STOCK'
  | 'MERCHANDISE_OUT_OF_STOCK'
  | 'MERCHANDISE_SELLING_PLAN_NOT_APPLICABLE_ON_COMPANY_LOCATION'
  | 'PAYMENTS_GIFT_CARDS_UNAVAILABLE'
  | 'PRODUCT_UNAVAILABLE_IN_BUYER_LOCATION';

export type CategoryFilter = {
  id: Scalars['String'];
};

export type Collection = HasMetafields & Node & OnlineStorePublishable & Trackable & {
  __typename?: 'Collection';
  description: Scalars['String'];
  descriptionHtml: Scalars['HTML'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  products: ProductConnection;
  seo: Seo;
  title: Scalars['String'];
  trackingParameters?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CollectionDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


export type CollectionMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type CollectionMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};


export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ProductFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductCollectionSortKeys>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  edges: Array<CollectionEdge>;
  nodes: Array<Collection>;
  pageInfo: PageInfo;
  totalCount: Scalars['UnsignedInt64'];
};

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  cursor: Scalars['String'];
  node: Collection;
};

export type CollectionSortKeys =
  | 'ID'
  | 'RELEVANCE'
  | 'TITLE'
  | 'UPDATED_AT';

export type Comment = Node & {
  __typename?: 'Comment';
  author: CommentAuthor;
  content: Scalars['String'];
  contentHtml: Scalars['HTML'];
  id: Scalars['ID'];
};


export type CommentContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};

export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<CommentEdge>;
  nodes: Array<Comment>;
  pageInfo: PageInfo;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Scalars['String'];
  node: Comment;
};

export type Company = HasMetafields & Node & {
  __typename?: 'Company';
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CompanyMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type CompanyMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type CompanyContact = Node & {
  __typename?: 'CompanyContact';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CompanyLocation = HasMetafields & Node & {
  __typename?: 'CompanyLocation';
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CompanyLocationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type CompanyLocationMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type CompletePaymentChallenge = {
  __typename?: 'CompletePaymentChallenge';
  redirectUrl?: Maybe<Scalars['URL']>;
};

export type CompletionError = {
  __typename?: 'CompletionError';
  code: CompletionErrorCode;
  message?: Maybe<Scalars['String']>;
};

export type CompletionErrorCode =
  | 'ERROR'
  | 'INVENTORY_RESERVATION_ERROR'
  | 'PAYMENT_AMOUNT_TOO_SMALL'
  | 'PAYMENT_CALL_ISSUER'
  | 'PAYMENT_CARD_DECLINED'
  | 'PAYMENT_ERROR'
  | 'PAYMENT_GATEWAY_NOT_ENABLED_ERROR'
  | 'PAYMENT_INSUFFICIENT_FUNDS'
  | 'PAYMENT_INVALID_BILLING_ADDRESS'
  | 'PAYMENT_INVALID_CREDIT_CARD'
  | 'PAYMENT_INVALID_CURRENCY'
  | 'PAYMENT_INVALID_PAYMENT_METHOD'
  | 'PAYMENT_TRANSIENT_ERROR';

export type ComponentizableCartLine = BaseCartLine & Node & {
  __typename?: 'ComponentizableCartLine';
  attribute?: Maybe<Attribute>;
  attributes: Array<Attribute>;
  cost: CartLineCost;
  discountAllocations: Array<CartDiscountAllocation>;
  /** @deprecated Use `cost` instead. */
  estimatedCost: CartLineEstimatedCost;
  id: Scalars['ID'];
  lineComponents: Array<CartLine>;
  merchandise: Merchandise;
  quantity: Scalars['Int'];
  sellingPlanAllocation?: Maybe<SellingPlanAllocation>;
  viewKey?: Maybe<Scalars['String']>;
};


export type ComponentizableCartLineAttributeArgs = {
  key: Scalars['String'];
};


export type ComponentizableCartLineDiscountAllocationsArgs = {
  lineLevelOnly?: InputMaybe<Scalars['Boolean']>;
};

export type Count = {
  __typename?: 'Count';
  count: Scalars['Int'];
  precision: CountPrecision;
};

export type CountPrecision =
  | 'AT_LEAST'
  | 'EXACT';

export type Country = {
  __typename?: 'Country';
  availableLanguages: Array<Language>;
  currency: Currency;
  defaultLanguage: Language;
  isoCode: CountryCode;
  /** @deprecated This `market` field will be removed in a future version of the API. */
  market?: Maybe<Market>;
  name: Scalars['String'];
  unitSystem: UnitSystem;
};

export type CountryCode =
  | 'AC'
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AR'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PS'
  | 'PT'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TA'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW'
  | 'ZZ';

export type CropRegion =
  | 'BOTTOM'
  | 'CENTER'
  | 'LEFT'
  | 'RIGHT'
  | 'TOP';

export type Currency = {
  __typename?: 'Currency';
  isoCode: CurrencyCode;
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type CurrencyCode =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BWP'
  | 'BYN'
  | 'BYR'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'CRC'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JEP'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KID'
  | 'KMF'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LTL'
  | 'LVL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRU'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SSP'
  | 'STD'
  | 'STN'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMT'
  | 'TND'
  | 'TOP'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'UYU'
  | 'UZS'
  | 'VED'
  | 'VEF'
  | 'VES'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XAF'
  | 'XCD'
  | 'XOF'
  | 'XPF'
  | 'XXX'
  | 'YER'
  | 'ZAR'
  | 'ZMW';

export type Customer = HasMetafields & {
  __typename?: 'Customer';
  acceptsMarketing: Scalars['Boolean'];
  addresses: MailingAddressConnection;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultAddress?: Maybe<MailingAddress>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  numberOfOrders: Scalars['UnsignedInt64'];
  orders: OrderConnection;
  phone?: Maybe<Scalars['String']>;
  socialLoginProvider?: Maybe<SocialLoginProvider>;
  tags: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type CustomerAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type CustomerMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type CustomerMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};


export type CustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};

export type CustomerAccessToken = {
  __typename?: 'CustomerAccessToken';
  accessToken: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

export type CustomerAccessTokenCreateInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type CustomerAccessTokenCreatePayload = {
  __typename?: 'CustomerAccessTokenCreatePayload';
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerAccessTokenCreateWithMultipassPayload = {
  __typename?: 'CustomerAccessTokenCreateWithMultipassPayload';
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
};

export type CustomerAccessTokenDeletePayload = {
  __typename?: 'CustomerAccessTokenDeletePayload';
  deletedAccessToken?: Maybe<Scalars['String']>;
  deletedCustomerAccessTokenId?: Maybe<Scalars['String']>;
  userErrors: Array<UserError>;
};

export type CustomerAccessTokenRenewPayload = {
  __typename?: 'CustomerAccessTokenRenewPayload';
  customerAccessToken?: Maybe<CustomerAccessToken>;
  userErrors: Array<UserError>;
};

export type CustomerActivateByUrlPayload = {
  __typename?: 'CustomerActivateByUrlPayload';
  customer?: Maybe<Customer>;
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
};

export type CustomerActivateInput = {
  activationToken: Scalars['String'];
  password: Scalars['String'];
};

export type CustomerActivatePayload = {
  __typename?: 'CustomerActivatePayload';
  customer?: Maybe<Customer>;
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerAddressCreatePayload = {
  __typename?: 'CustomerAddressCreatePayload';
  customerAddress?: Maybe<MailingAddress>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerAddressDeletePayload = {
  __typename?: 'CustomerAddressDeletePayload';
  customerUserErrors: Array<CustomerUserError>;
  deletedCustomerAddressId?: Maybe<Scalars['String']>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerAddressUpdatePayload = {
  __typename?: 'CustomerAddressUpdatePayload';
  customerAddress?: Maybe<MailingAddress>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerCreateInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type CustomerCreatePayload = {
  __typename?: 'CustomerCreatePayload';
  customer?: Maybe<Customer>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerDefaultAddressUpdatePayload = {
  __typename?: 'CustomerDefaultAddressUpdatePayload';
  customer?: Maybe<Customer>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerErrorCode =
  | 'ALREADY_ENABLED'
  | 'BAD_DOMAIN'
  | 'BLANK'
  | 'CONTAINS_HTML_TAGS'
  | 'CONTAINS_URL'
  | 'CUSTOMER_DISABLED'
  | 'INVALID'
  | 'INVALID_MULTIPASS_REQUEST'
  | 'NOT_FOUND'
  | 'PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE'
  | 'TAKEN'
  | 'TOKEN_INVALID'
  | 'TOO_LONG'
  | 'TOO_SHORT'
  | 'UNIDENTIFIED_CUSTOMER';

export type CustomerRecoverPayload = {
  __typename?: 'CustomerRecoverPayload';
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerResetByUrlPayload = {
  __typename?: 'CustomerResetByUrlPayload';
  customer?: Maybe<Customer>;
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerResetInput = {
  password: Scalars['String'];
  resetToken: Scalars['String'];
};

export type CustomerResetPayload = {
  __typename?: 'CustomerResetPayload';
  customer?: Maybe<Customer>;
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerUpdateInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  customer?: Maybe<Customer>;
  customerAccessToken?: Maybe<CustomerAccessToken>;
  customerUserErrors: Array<CustomerUserError>;
  /** @deprecated Use `customerUserErrors` instead. */
  userErrors: Array<UserError>;
};

export type CustomerUserError = DisplayableError & {
  __typename?: 'CustomerUserError';
  code?: Maybe<CustomerErrorCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type DeliveryAddress = MailingAddress;

export type DeliveryAddressInput = {
  customerAddressId?: InputMaybe<Scalars['ID']>;
  deliveryAddress?: InputMaybe<MailingAddressInput>;
  deliveryAddressValidationStrategy?: InputMaybe<DeliveryAddressValidationStrategy>;
  oneTimeUse?: InputMaybe<Scalars['Boolean']>;
};

export type DeliveryAddressValidationStrategy =
  | 'COUNTRY_CODE_ONLY'
  | 'STRICT';

export type DeliveryMethodType =
  | 'LOCAL'
  | 'NONE'
  | 'PICKUP_POINT'
  | 'PICK_UP'
  | 'RETAIL'
  | 'SHIPPING';

export type DigitalWallet =
  | 'ANDROID_PAY'
  | 'APPLE_PAY'
  | 'GOOGLE_PAY'
  | 'SHOPIFY_PAY';

export type DiscountAllocation = {
  __typename?: 'DiscountAllocation';
  allocatedAmount: MoneyV2;
  discountApplication: DiscountApplication;
};

export type DiscountApplication = {
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  value: PricingValue;
};

export type DiscountApplicationAllocationMethod =
  | 'ACROSS'
  | 'EACH'
  | 'ONE';

export type DiscountApplicationConnection = {
  __typename?: 'DiscountApplicationConnection';
  edges: Array<DiscountApplicationEdge>;
  nodes: Array<DiscountApplication>;
  pageInfo: PageInfo;
};

export type DiscountApplicationEdge = {
  __typename?: 'DiscountApplicationEdge';
  cursor: Scalars['String'];
  node: DiscountApplication;
};

export type DiscountApplicationTargetSelection =
  | 'ALL'
  | 'ENTITLED'
  | 'EXPLICIT';

export type DiscountApplicationTargetType =
  | 'LINE_ITEM'
  | 'SHIPPING_LINE';

export type DiscountCodeApplication = DiscountApplication & {
  __typename?: 'DiscountCodeApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  applicable: Scalars['Boolean'];
  code: Scalars['String'];
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  value: PricingValue;
};

export type DisplayableError = {
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type Domain = {
  __typename?: 'Domain';
  host: Scalars['String'];
  sslEnabled: Scalars['Boolean'];
  url: Scalars['URL'];
};

export type ExternalVideo = Media & Node & {
  __typename?: 'ExternalVideo';
  alt?: Maybe<Scalars['String']>;
  embedUrl: Scalars['URL'];
  /** @deprecated Use `originUrl` instead. */
  embeddedUrl: Scalars['URL'];
  host: MediaHost;
  id: Scalars['ID'];
  mediaContentType: MediaContentType;
  originUrl: Scalars['URL'];
  presentation?: Maybe<MediaPresentation>;
  previewImage?: Maybe<Image>;
};

export type Filter = {
  __typename?: 'Filter';
  id: Scalars['String'];
  label: Scalars['String'];
  presentation?: Maybe<FilterPresentation>;
  type: FilterType;
  values: Array<FilterValue>;
};

export type FilterPresentation =
  | 'IMAGE'
  | 'SWATCH'
  | 'TEXT';

export type FilterType =
  | 'BOOLEAN'
  | 'LIST'
  | 'PRICE_RANGE';

export type FilterValue = {
  __typename?: 'FilterValue';
  count: Scalars['Int'];
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  input: Scalars['JSON'];
  label: Scalars['String'];
  swatch?: Maybe<Swatch>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  fulfillmentLineItems: FulfillmentLineItemConnection;
  trackingCompany?: Maybe<Scalars['String']>;
  trackingInfo: Array<FulfillmentTrackingInfo>;
};


export type FulfillmentFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type FulfillmentTrackingInfoArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

export type FulfillmentLineItem = {
  __typename?: 'FulfillmentLineItem';
  lineItem: OrderLineItem;
  quantity: Scalars['Int'];
};

export type FulfillmentLineItemConnection = {
  __typename?: 'FulfillmentLineItemConnection';
  edges: Array<FulfillmentLineItemEdge>;
  nodes: Array<FulfillmentLineItem>;
  pageInfo: PageInfo;
};

export type FulfillmentLineItemEdge = {
  __typename?: 'FulfillmentLineItemEdge';
  cursor: Scalars['String'];
  node: FulfillmentLineItem;
};

export type FulfillmentTrackingInfo = {
  __typename?: 'FulfillmentTrackingInfo';
  number?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type GenericFile = Node & {
  __typename?: 'GenericFile';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mimeType?: Maybe<Scalars['String']>;
  originalFileSize?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Image>;
  url?: Maybe<Scalars['URL']>;
};

export type GeoCoordinateInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type HasMetafields = {
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
};


export type HasMetafieldsMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type HasMetafieldsMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type HasMetafieldsIdentifier = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Use `url` instead. */
  originalSrc: Scalars['URL'];
  /** @deprecated Use `url` instead. */
  src: Scalars['URL'];
  thumbhash?: Maybe<Scalars['String']>;
  /** @deprecated Use `url(transform:)` instead */
  transformedSrc: Scalars['URL'];
  url: Scalars['URL'];
  width?: Maybe<Scalars['Int']>;
};


export type ImageTransformedSrcArgs = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  preferredContentType?: InputMaybe<ImageContentType>;
  scale?: InputMaybe<Scalars['Int']>;
};


export type ImageUrlArgs = {
  transform?: InputMaybe<ImageTransformInput>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges: Array<ImageEdge>;
  nodes: Array<Image>;
  pageInfo: PageInfo;
};

export type ImageContentType =
  | 'JPG'
  | 'PNG'
  | 'WEBP';

export type ImageEdge = {
  __typename?: 'ImageEdge';
  cursor: Scalars['String'];
  node: Image;
};

export type ImageTransformInput = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  preferredContentType?: InputMaybe<ImageContentType>;
  scale?: InputMaybe<Scalars['Int']>;
};

export type Language = {
  __typename?: 'Language';
  endonymName: Scalars['String'];
  isoCode: LanguageCode;
  name: Scalars['String'];
};

export type LanguageCode =
  | 'AF'
  | 'AK'
  | 'AM'
  | 'AR'
  | 'AS'
  | 'AZ'
  | 'BE'
  | 'BG'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BR'
  | 'BS'
  | 'CA'
  | 'CE'
  | 'CKB'
  | 'CS'
  | 'CU'
  | 'CY'
  | 'DA'
  | 'DE'
  | 'DZ'
  | 'EE'
  | 'EL'
  | 'EN'
  | 'EO'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FA'
  | 'FF'
  | 'FI'
  | 'FIL'
  | 'FO'
  | 'FR'
  | 'FY'
  | 'GA'
  | 'GD'
  | 'GL'
  | 'GU'
  | 'GV'
  | 'HA'
  | 'HE'
  | 'HI'
  | 'HR'
  | 'HU'
  | 'HY'
  | 'IA'
  | 'ID'
  | 'IG'
  | 'II'
  | 'IS'
  | 'IT'
  | 'JA'
  | 'JV'
  | 'KA'
  | 'KI'
  | 'KK'
  | 'KL'
  | 'KM'
  | 'KN'
  | 'KO'
  | 'KS'
  | 'KU'
  | 'KW'
  | 'KY'
  | 'LA'
  | 'LB'
  | 'LG'
  | 'LN'
  | 'LO'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'MG'
  | 'MI'
  | 'MK'
  | 'ML'
  | 'MN'
  | 'MO'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MY'
  | 'NB'
  | 'ND'
  | 'NE'
  | 'NL'
  | 'NN'
  | 'NO'
  | 'OM'
  | 'OR'
  | 'OS'
  | 'PA'
  | 'PL'
  | 'PS'
  | 'PT'
  | 'PT_BR'
  | 'PT_PT'
  | 'QU'
  | 'RM'
  | 'RN'
  | 'RO'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SK'
  | 'SL'
  | 'SN'
  | 'SO'
  | 'SQ'
  | 'SR'
  | 'SU'
  | 'SV'
  | 'SW'
  | 'TA'
  | 'TE'
  | 'TG'
  | 'TH'
  | 'TI'
  | 'TK'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'UG'
  | 'UK'
  | 'UR'
  | 'UZ'
  | 'VI'
  | 'VO'
  | 'WO'
  | 'XH'
  | 'YI'
  | 'YO'
  | 'ZH'
  | 'ZH_CN'
  | 'ZH_TW'
  | 'ZU';

export type Localization = {
  __typename?: 'Localization';
  availableCountries: Array<Country>;
  availableLanguages: Array<Language>;
  country: Country;
  language: Language;
  /** @deprecated This `market` field will be removed in a future version of the API. */
  market: Market;
};

export type Location = HasMetafields & Node & {
  __typename?: 'Location';
  address: LocationAddress;
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  name: Scalars['String'];
};


export type LocationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type LocationMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type LocationAddress = {
  __typename?: 'LocationAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  formatted: Array<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges: Array<LocationEdge>;
  nodes: Array<Location>;
  pageInfo: PageInfo;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['String'];
  node: Location;
};

export type LocationSortKeys =
  | 'CITY'
  | 'DISTANCE'
  | 'ID'
  | 'NAME';

export type MailingAddress = Node & {
  __typename?: 'MailingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** @deprecated Use `countryCodeV2` instead. */
  countryCode?: Maybe<Scalars['String']>;
  countryCodeV2?: Maybe<CountryCode>;
  firstName?: Maybe<Scalars['String']>;
  formatted: Array<Scalars['String']>;
  formattedArea?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type MailingAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']>;
  withName?: InputMaybe<Scalars['Boolean']>;
};

export type MailingAddressConnection = {
  __typename?: 'MailingAddressConnection';
  edges: Array<MailingAddressEdge>;
  nodes: Array<MailingAddress>;
  pageInfo: PageInfo;
};

export type MailingAddressEdge = {
  __typename?: 'MailingAddressEdge';
  cursor: Scalars['String'];
  node: MailingAddress;
};

export type MailingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ManualDiscountApplication = DiscountApplication & {
  __typename?: 'ManualDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  description?: Maybe<Scalars['String']>;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
  value: PricingValue;
};

export type Market = HasMetafields & Node & {
  __typename?: 'Market';
  handle: Scalars['String'];
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
};


export type MarketMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type MarketMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type Media = {
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaContentType: MediaContentType;
  presentation?: Maybe<MediaPresentation>;
  previewImage?: Maybe<Image>;
};

export type MediaConnection = {
  __typename?: 'MediaConnection';
  edges: Array<MediaEdge>;
  nodes: Array<Media>;
  pageInfo: PageInfo;
};

export type MediaContentType =
  | 'EXTERNAL_VIDEO'
  | 'IMAGE'
  | 'MODEL_3D'
  | 'VIDEO';

export type MediaEdge = {
  __typename?: 'MediaEdge';
  cursor: Scalars['String'];
  node: Media;
};

export type MediaHost =
  | 'VIMEO'
  | 'YOUTUBE';

export type MediaImage = Media & Node & {
  __typename?: 'MediaImage';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  mediaContentType: MediaContentType;
  presentation?: Maybe<MediaPresentation>;
  previewImage?: Maybe<Image>;
};

export type MediaPresentation = Node & {
  __typename?: 'MediaPresentation';
  asJson?: Maybe<Scalars['JSON']>;
  /** @deprecated MediaPresentation IDs are being deprecated. Access the data directly via the asJson field on the Media type. */
  id: Scalars['ID'];
};


export type MediaPresentationAsJsonArgs = {
  format: MediaPresentationFormat;
};

export type MediaPresentationFormat =
  | 'IMAGE'
  | 'MODEL_VIEWER';

export type Menu = Node & {
  __typename?: 'Menu';
  handle: Scalars['String'];
  id: Scalars['ID'];
  items: Array<MenuItem>;
  itemsCount: Scalars['Int'];
  title: Scalars['String'];
};

export type MenuItem = Node & {
  __typename?: 'MenuItem';
  id: Scalars['ID'];
  items: Array<MenuItem>;
  resource?: Maybe<MenuItemResource>;
  resourceId?: Maybe<Scalars['ID']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: MenuItemType;
  url?: Maybe<Scalars['URL']>;
};

export type MenuItemResource = Article | Blog | Collection | Metaobject | Page | Product | ShopPolicy;

export type MenuItemType =
  | 'ARTICLE'
  | 'BLOG'
  | 'CATALOG'
  | 'COLLECTION'
  | 'COLLECTIONS'
  | 'CUSTOMER_ACCOUNT_PAGE'
  | 'FRONTPAGE'
  | 'HTTP'
  | 'METAOBJECT'
  | 'PAGE'
  | 'PRODUCT'
  | 'SEARCH'
  | 'SHOP_POLICY';

export type Merchandise = ProductVariant;

export type Metafield = Node & {
  __typename?: 'Metafield';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  list: Scalars['Boolean'];
  namespace: Scalars['String'];
  parentResource: MetafieldParentResource;
  reference?: Maybe<MetafieldReference>;
  references?: Maybe<MetafieldReferenceConnection>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};


export type MetafieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetafieldDeleteErrorCode =
  | 'APP_NOT_AUTHORIZED'
  | 'INVALID_OWNER'
  | 'METAFIELD_DOES_NOT_EXIST';

export type MetafieldDeleteUserError = DisplayableError & {
  __typename?: 'MetafieldDeleteUserError';
  code?: Maybe<MetafieldDeleteErrorCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type MetafieldFilter = {
  key: Scalars['String'];
  namespace: Scalars['String'];
  value: Scalars['String'];
};

export type MetafieldParentResource = Article | Blog | Cart | Collection | Company | CompanyLocation | Customer | Location | Market | Order | Page | Product | ProductVariant | SellingPlan | Shop;

export type MetafieldReference = Article | Collection | GenericFile | MediaImage | Metaobject | Model3d | Page | Product | ProductVariant | Video;

export type MetafieldReferenceConnection = {
  __typename?: 'MetafieldReferenceConnection';
  edges: Array<MetafieldReferenceEdge>;
  nodes: Array<MetafieldReference>;
  pageInfo: PageInfo;
};

export type MetafieldReferenceEdge = {
  __typename?: 'MetafieldReferenceEdge';
  cursor: Scalars['String'];
  node: MetafieldReference;
};

export type MetafieldsSetUserError = DisplayableError & {
  __typename?: 'MetafieldsSetUserError';
  code?: Maybe<MetafieldsSetUserErrorCode>;
  elementIndex?: Maybe<Scalars['Int']>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type MetafieldsSetUserErrorCode =
  | 'APP_NOT_AUTHORIZED'
  | 'BLANK'
  | 'INCLUSION'
  | 'INVALID_OWNER'
  | 'INVALID_TYPE'
  | 'INVALID_VALUE'
  | 'LESS_THAN_OR_EQUAL_TO'
  | 'PRESENT'
  | 'TOO_LONG'
  | 'TOO_SHORT';

export type Metaobject = Node & OnlineStorePublishable & {
  __typename?: 'Metaobject';
  field?: Maybe<MetaobjectField>;
  fields: Array<MetaobjectField>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  seo?: Maybe<MetaobjectSeo>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MetaobjectFieldArgs = {
  key: Scalars['String'];
};

export type MetaobjectConnection = {
  __typename?: 'MetaobjectConnection';
  edges: Array<MetaobjectEdge>;
  nodes: Array<Metaobject>;
  pageInfo: PageInfo;
};

export type MetaobjectEdge = {
  __typename?: 'MetaobjectEdge';
  cursor: Scalars['String'];
  node: Metaobject;
};

export type MetaobjectField = {
  __typename?: 'MetaobjectField';
  key: Scalars['String'];
  reference?: Maybe<MetafieldReference>;
  references?: Maybe<MetafieldReferenceConnection>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};


export type MetaobjectFieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetaobjectHandleInput = {
  handle: Scalars['String'];
  type: Scalars['String'];
};

export type MetaobjectSeo = {
  __typename?: 'MetaobjectSEO';
  description?: Maybe<MetaobjectField>;
  title?: Maybe<MetaobjectField>;
};

export type Model3d = Media & Node & {
  __typename?: 'Model3d';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaContentType: MediaContentType;
  presentation?: Maybe<MediaPresentation>;
  previewImage?: Maybe<Image>;
  sources: Array<Model3dSource>;
};

export type Model3dSource = {
  __typename?: 'Model3dSource';
  filesize: Scalars['Int'];
  format: Scalars['String'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
};

export type MoneyInput = {
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

export type Mutation = {
  __typename?: 'Mutation';
  cartAttributesUpdate?: Maybe<CartAttributesUpdatePayload>;
  cartBillingAddressUpdate?: Maybe<CartBillingAddressUpdatePayload>;
  cartBuyerIdentityUpdate?: Maybe<CartBuyerIdentityUpdatePayload>;
  cartClone?: Maybe<CartClonePayload>;
  cartCreate?: Maybe<CartCreatePayload>;
  cartDeliveryAddressesAdd?: Maybe<CartDeliveryAddressesAddPayload>;
  cartDeliveryAddressesRemove?: Maybe<CartDeliveryAddressesRemovePayload>;
  cartDeliveryAddressesReplace?: Maybe<CartDeliveryAddressesReplacePayload>;
  cartDeliveryAddressesUpdate?: Maybe<CartDeliveryAddressesUpdatePayload>;
  cartDiscountCodesUpdate?: Maybe<CartDiscountCodesUpdatePayload>;
  cartGiftCardCodesAdd?: Maybe<CartGiftCardCodesAddPayload>;
  cartGiftCardCodesRemove?: Maybe<CartGiftCardCodesRemovePayload>;
  cartGiftCardCodesUpdate?: Maybe<CartGiftCardCodesUpdatePayload>;
  cartLinesAdd?: Maybe<CartLinesAddPayload>;
  cartLinesRemove?: Maybe<CartLinesRemovePayload>;
  cartLinesUpdate?: Maybe<CartLinesUpdatePayload>;
  cartMetafieldDelete?: Maybe<CartMetafieldDeletePayload>;
  cartMetafieldsSet?: Maybe<CartMetafieldsSetPayload>;
  cartNoteUpdate?: Maybe<CartNoteUpdatePayload>;
  cartPaymentUpdate?: Maybe<CartPaymentUpdatePayload>;
  cartPrepareForCompletion?: Maybe<CartPrepareForCompletionPayload>;
  cartRemovePersonalData?: Maybe<CartRemovePersonalDataPayload>;
  cartSelectedDeliveryOptionsUpdate?: Maybe<CartSelectedDeliveryOptionsUpdatePayload>;
  cartSubmitForCompletion?: Maybe<CartSubmitForCompletionPayload>;
  customerAccessTokenCreate?: Maybe<CustomerAccessTokenCreatePayload>;
  customerAccessTokenCreateWithMultipass?: Maybe<CustomerAccessTokenCreateWithMultipassPayload>;
  customerAccessTokenDelete?: Maybe<CustomerAccessTokenDeletePayload>;
  customerAccessTokenRenew?: Maybe<CustomerAccessTokenRenewPayload>;
  customerActivate?: Maybe<CustomerActivatePayload>;
  customerActivateByUrl?: Maybe<CustomerActivateByUrlPayload>;
  customerAddressCreate?: Maybe<CustomerAddressCreatePayload>;
  customerAddressDelete?: Maybe<CustomerAddressDeletePayload>;
  customerAddressUpdate?: Maybe<CustomerAddressUpdatePayload>;
  customerCreate?: Maybe<CustomerCreatePayload>;
  customerDefaultAddressUpdate?: Maybe<CustomerDefaultAddressUpdatePayload>;
  customerRecover?: Maybe<CustomerRecoverPayload>;
  customerReset?: Maybe<CustomerResetPayload>;
  customerResetByUrl?: Maybe<CustomerResetByUrlPayload>;
  customerUpdate?: Maybe<CustomerUpdatePayload>;
  shopPayPaymentRequestSessionCreate?: Maybe<ShopPayPaymentRequestSessionCreatePayload>;
  shopPayPaymentRequestSessionSubmit?: Maybe<ShopPayPaymentRequestSessionSubmitPayload>;
};


export type MutationCartAttributesUpdateArgs = {
  attributes: Array<AttributeInput>;
  cartId: Scalars['ID'];
};


export type MutationCartBillingAddressUpdateArgs = {
  billingAddress?: InputMaybe<MailingAddressInput>;
  cartId: Scalars['ID'];
};


export type MutationCartBuyerIdentityUpdateArgs = {
  buyerIdentity: CartBuyerIdentityInput;
  cartId: Scalars['ID'];
};


export type MutationCartCloneArgs = {
  cartId: Scalars['ID'];
};


export type MutationCartCreateArgs = {
  input?: InputMaybe<CartInput>;
};


export type MutationCartDeliveryAddressesAddArgs = {
  addresses: Array<CartSelectableAddressInput>;
  cartId: Scalars['ID'];
};


export type MutationCartDeliveryAddressesRemoveArgs = {
  addressIds: Array<Scalars['ID']>;
  cartId: Scalars['ID'];
};


export type MutationCartDeliveryAddressesReplaceArgs = {
  addresses: Array<CartSelectableAddressInput>;
  cartId: Scalars['ID'];
};


export type MutationCartDeliveryAddressesUpdateArgs = {
  addresses: Array<CartSelectableAddressUpdateInput>;
  cartId: Scalars['ID'];
};


export type MutationCartDiscountCodesUpdateArgs = {
  cartId: Scalars['ID'];
  discountCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationCartGiftCardCodesAddArgs = {
  cartId: Scalars['ID'];
  giftCardCodes: Array<Scalars['String']>;
};


export type MutationCartGiftCardCodesRemoveArgs = {
  appliedGiftCardIds: Array<Scalars['ID']>;
  cartId: Scalars['ID'];
};


export type MutationCartGiftCardCodesUpdateArgs = {
  cartId: Scalars['ID'];
  giftCardCodes: Array<Scalars['String']>;
};


export type MutationCartLinesAddArgs = {
  cartId: Scalars['ID'];
  lines: Array<CartLineInput>;
};


export type MutationCartLinesRemoveArgs = {
  cartId: Scalars['ID'];
  lineIds?: InputMaybe<Array<Scalars['ID']>>;
  viewKeys?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationCartLinesUpdateArgs = {
  cartId: Scalars['ID'];
  lines: Array<CartLineUpdateInput>;
};


export type MutationCartMetafieldDeleteArgs = {
  input: CartMetafieldDeleteInput;
};


export type MutationCartMetafieldsSetArgs = {
  metafields: Array<CartMetafieldsSetInput>;
};


export type MutationCartNoteUpdateArgs = {
  cartId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationCartPaymentUpdateArgs = {
  cartId: Scalars['ID'];
  payment: CartPaymentInput;
};


export type MutationCartPrepareForCompletionArgs = {
  cartId: Scalars['ID'];
};


export type MutationCartRemovePersonalDataArgs = {
  cartId: Scalars['ID'];
};


export type MutationCartSelectedDeliveryOptionsUpdateArgs = {
  cartId: Scalars['ID'];
  selectedDeliveryOptions: Array<CartSelectedDeliveryOptionInput>;
};


export type MutationCartSubmitForCompletionArgs = {
  attemptToken: Scalars['String'];
  cartId: Scalars['ID'];
};


export type MutationCustomerAccessTokenCreateArgs = {
  input: CustomerAccessTokenCreateInput;
};


export type MutationCustomerAccessTokenCreateWithMultipassArgs = {
  multipassToken: Scalars['String'];
};


export type MutationCustomerAccessTokenDeleteArgs = {
  customerAccessToken: Scalars['String'];
};


export type MutationCustomerAccessTokenRenewArgs = {
  customerAccessToken: Scalars['String'];
};


export type MutationCustomerActivateArgs = {
  id: Scalars['ID'];
  input: CustomerActivateInput;
};


export type MutationCustomerActivateByUrlArgs = {
  activationUrl: Scalars['URL'];
  password: Scalars['String'];
};


export type MutationCustomerAddressCreateArgs = {
  address: MailingAddressInput;
  customerAccessToken: Scalars['String'];
};


export type MutationCustomerAddressDeleteArgs = {
  customerAccessToken: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCustomerAddressUpdateArgs = {
  address: MailingAddressInput;
  customerAccessToken: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerDefaultAddressUpdateArgs = {
  addressId: Scalars['ID'];
  customerAccessToken: Scalars['String'];
};


export type MutationCustomerRecoverArgs = {
  email: Scalars['String'];
};


export type MutationCustomerResetArgs = {
  id: Scalars['ID'];
  input: CustomerResetInput;
};


export type MutationCustomerResetByUrlArgs = {
  password: Scalars['String'];
  resetUrl: Scalars['URL'];
};


export type MutationCustomerUpdateArgs = {
  customer: CustomerUpdateInput;
  customerAccessToken: Scalars['String'];
};


export type MutationShopPayPaymentRequestSessionCreateArgs = {
  paymentRequest: ShopPayPaymentRequestInput;
  sourceIdentifier: Scalars['String'];
};


export type MutationShopPayPaymentRequestSessionSubmitArgs = {
  idempotencyKey: Scalars['String'];
  orderName?: InputMaybe<Scalars['String']>;
  paymentRequest: ShopPayPaymentRequestInput;
  token: Scalars['String'];
};

export type Node = {
  id: Scalars['ID'];
};

export type OnlineStorePublishable = {
  onlineStoreUrl?: Maybe<Scalars['URL']>;
};

export type Order = HasMetafields & Node & {
  __typename?: 'Order';
  billingAddress?: Maybe<MailingAddress>;
  cancelReason?: Maybe<OrderCancelReason>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  currencyCode: CurrencyCode;
  currentSubtotalPrice: MoneyV2;
  currentTotalDuties?: Maybe<MoneyV2>;
  currentTotalPrice: MoneyV2;
  currentTotalShippingPrice: MoneyV2;
  currentTotalTax: MoneyV2;
  customAttributes: Array<Attribute>;
  customerLocale?: Maybe<Scalars['String']>;
  customerUrl?: Maybe<Scalars['URL']>;
  discountApplications: DiscountApplicationConnection;
  edited: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  financialStatus?: Maybe<OrderFinancialStatus>;
  fulfillmentStatus: OrderFulfillmentStatus;
  id: Scalars['ID'];
  lineItems: OrderLineItemConnection;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  name: Scalars['String'];
  orderNumber: Scalars['Int'];
  originalTotalDuties?: Maybe<MoneyV2>;
  originalTotalPrice: MoneyV2;
  phone?: Maybe<Scalars['String']>;
  processedAt: Scalars['DateTime'];
  shippingAddress?: Maybe<MailingAddress>;
  shippingDiscountAllocations: Array<DiscountAllocation>;
  statusUrl: Scalars['URL'];
  subtotalPrice?: Maybe<MoneyV2>;
  /** @deprecated Use `subtotalPrice` instead. */
  subtotalPriceV2?: Maybe<MoneyV2>;
  successfulFulfillments?: Maybe<Array<Fulfillment>>;
  totalPrice: MoneyV2;
  /** @deprecated Use `totalPrice` instead. */
  totalPriceV2: MoneyV2;
  totalRefunded: MoneyV2;
  /** @deprecated Use `totalRefunded` instead. */
  totalRefundedV2: MoneyV2;
  totalShippingPrice: MoneyV2;
  /** @deprecated Use `totalShippingPrice` instead. */
  totalShippingPriceV2: MoneyV2;
  totalTax?: Maybe<MoneyV2>;
  /** @deprecated Use `totalTax` instead. */
  totalTaxV2?: Maybe<MoneyV2>;
};


export type OrderDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type OrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type OrderMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type OrderMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};


export type OrderSuccessfulFulfillmentsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

export type OrderCancelReason =
  | 'CUSTOMER'
  | 'DECLINED'
  | 'FRAUD'
  | 'INVENTORY'
  | 'OTHER'
  | 'STAFF';

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  nodes: Array<Order>;
  pageInfo: PageInfo;
  totalCount: Scalars['UnsignedInt64'];
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String'];
  node: Order;
};

export type OrderFinancialStatus =
  | 'AUTHORIZED'
  | 'PAID'
  | 'PARTIALLY_PAID'
  | 'PARTIALLY_REFUNDED'
  | 'PENDING'
  | 'REFUNDED'
  | 'VOIDED';

export type OrderFulfillmentStatus =
  | 'FULFILLED'
  | 'IN_PROGRESS'
  | 'ON_HOLD'
  | 'OPEN'
  | 'PARTIALLY_FULFILLED'
  | 'PENDING_FULFILLMENT'
  | 'RESTOCKED'
  | 'SCHEDULED'
  | 'UNFULFILLED';

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  currentQuantity: Scalars['Int'];
  customAttributes: Array<Attribute>;
  discountAllocations: Array<DiscountAllocation>;
  discountedTotalPrice: MoneyV2;
  originalTotalPrice: MoneyV2;
  quantity: Scalars['Int'];
  title: Scalars['String'];
  variant?: Maybe<ProductVariant>;
};

export type OrderLineItemConnection = {
  __typename?: 'OrderLineItemConnection';
  edges: Array<OrderLineItemEdge>;
  nodes: Array<OrderLineItem>;
  pageInfo: PageInfo;
};

export type OrderLineItemEdge = {
  __typename?: 'OrderLineItemEdge';
  cursor: Scalars['String'];
  node: OrderLineItem;
};

export type OrderSortKeys =
  | 'ID'
  | 'PROCESSED_AT'
  | 'RELEVANCE'
  | 'TOTAL_PRICE';

export type Page = HasMetafields & Node & OnlineStorePublishable & Trackable & {
  __typename?: 'Page';
  body: Scalars['HTML'];
  bodySummary: Scalars['String'];
  createdAt: Scalars['DateTime'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  seo?: Maybe<Seo>;
  title: Scalars['String'];
  trackingParameters?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type PageMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type PageMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type PageConnection = {
  __typename?: 'PageConnection';
  edges: Array<PageEdge>;
  nodes: Array<Page>;
  pageInfo: PageInfo;
};

export type PageEdge = {
  __typename?: 'PageEdge';
  cursor: Scalars['String'];
  node: Page;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PageSortKeys =
  | 'ID'
  | 'RELEVANCE'
  | 'TITLE'
  | 'UPDATED_AT';

export type PaginatedSitemapResources = {
  __typename?: 'PaginatedSitemapResources';
  hasNextPage: Scalars['Boolean'];
  items: Array<SitemapResourceInterface>;
};

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  acceptedCardBrands: Array<CardBrand>;
  cardVaultUrl: Scalars['URL'];
  countryCode: CountryCode;
  currencyCode: CurrencyCode;
  enabledPresentmentCurrencies: Array<CurrencyCode>;
  shopifyPaymentsAccountId?: Maybe<Scalars['String']>;
  supportedDigitalWallets: Array<DigitalWallet>;
};

export type PredictiveSearchLimitScope =
  | 'ALL'
  | 'EACH';

export type PredictiveSearchResult = {
  __typename?: 'PredictiveSearchResult';
  articles: Array<Article>;
  collections: Array<Collection>;
  pages: Array<Page>;
  products: Array<Product>;
  queries: Array<SearchQuerySuggestion>;
};

export type PredictiveSearchType =
  | 'ARTICLE'
  | 'COLLECTION'
  | 'PAGE'
  | 'PRODUCT'
  | 'QUERY';

export type PreferenceDeliveryMethodType =
  | 'PICKUP_POINT'
  | 'PICK_UP'
  | 'SHIPPING';

export type PriceRangeFilter = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type PricingPercentageValue = {
  __typename?: 'PricingPercentageValue';
  percentage: Scalars['Float'];
};

export type PricingValue = MoneyV2 | PricingPercentageValue;

export type Product = HasMetafields & Node & OnlineStorePublishable & Trackable & {
  __typename?: 'Product';
  adjacentVariants: Array<ProductVariant>;
  availableForSale: Scalars['Boolean'];
  category?: Maybe<TaxonomyCategory>;
  collections: CollectionConnection;
  compareAtPriceRange: ProductPriceRange;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  descriptionHtml: Scalars['HTML'];
  encodedVariantAvailability?: Maybe<Scalars['String']>;
  encodedVariantExistence?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Image>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  images: ImageConnection;
  isGiftCard: Scalars['Boolean'];
  media: MediaConnection;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  options: Array<ProductOption>;
  priceRange: ProductPriceRange;
  productType: Scalars['String'];
  publishedAt: Scalars['DateTime'];
  requiresSellingPlan: Scalars['Boolean'];
  selectedOrFirstAvailableVariant?: Maybe<ProductVariant>;
  sellingPlanGroups: SellingPlanGroupConnection;
  seo: Seo;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  totalInventory?: Maybe<Scalars['Int']>;
  trackingParameters?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  variantBySelectedOptions?: Maybe<ProductVariant>;
  variants: ProductVariantConnection;
  variantsCount?: Maybe<Count>;
  vendor: Scalars['String'];
};


export type ProductAdjacentVariantsArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']>;
  selectedOptions?: InputMaybe<Array<SelectedOptionInput>>;
};


export type ProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type ProductDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


export type ProductImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


export type ProductMediaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductMediaSortKeys>;
};


export type ProductMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type ProductMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};


export type ProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


export type ProductSelectedOrFirstAvailableVariantArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']>;
  selectedOptions?: InputMaybe<Array<SelectedOptionInput>>;
};


export type ProductSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type ProductVariantBySelectedOptionsArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']>;
  selectedOptions: Array<SelectedOptionInput>;
};


export type ProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};

export type ProductCollectionSortKeys =
  | 'BEST_SELLING'
  | 'COLLECTION_DEFAULT'
  | 'CREATED'
  | 'ID'
  | 'MANUAL'
  | 'PRICE'
  | 'RELEVANCE'
  | 'TITLE';

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  filters: Array<Filter>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String'];
  node: Product;
};

export type ProductFilter = {
  available?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<CategoryFilter>;
  price?: InputMaybe<PriceRangeFilter>;
  productMetafield?: InputMaybe<MetafieldFilter>;
  productType?: InputMaybe<Scalars['String']>;
  productVendor?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  taxonomyMetafield?: InputMaybe<TaxonomyMetafieldFilter>;
  variantMetafield?: InputMaybe<MetafieldFilter>;
  variantOption?: InputMaybe<VariantOptionFilter>;
};

export type ProductImageSortKeys =
  | 'CREATED_AT'
  | 'ID'
  | 'POSITION'
  | 'RELEVANCE';

export type ProductMediaSortKeys =
  | 'ID'
  | 'POSITION'
  | 'RELEVANCE';

export type ProductOption = Node & {
  __typename?: 'ProductOption';
  id: Scalars['ID'];
  name: Scalars['String'];
  optionValues: Array<ProductOptionValue>;
  /** @deprecated Use `optionValues` instead. */
  values: Array<Scalars['String']>;
};

export type ProductOptionValue = Node & {
  __typename?: 'ProductOptionValue';
  firstSelectableVariant?: Maybe<ProductVariant>;
  id: Scalars['ID'];
  name: Scalars['String'];
  swatch?: Maybe<ProductOptionValueSwatch>;
};

export type ProductOptionValueSwatch = {
  __typename?: 'ProductOptionValueSwatch';
  color?: Maybe<Scalars['Color']>;
  image?: Maybe<Media>;
};

export type ProductPriceRange = {
  __typename?: 'ProductPriceRange';
  maxVariantPrice: MoneyV2;
  minVariantPrice: MoneyV2;
};

export type ProductRecommendationIntent =
  | 'COMPLEMENTARY'
  | 'RELATED';

export type ProductSortKeys =
  | 'BEST_SELLING'
  | 'CREATED_AT'
  | 'ID'
  | 'PRICE'
  | 'PRODUCT_TYPE'
  | 'RELEVANCE'
  | 'TITLE'
  | 'UPDATED_AT'
  | 'VENDOR';

export type ProductVariant = HasMetafields & Node & {
  __typename?: 'ProductVariant';
  availableForSale: Scalars['Boolean'];
  barcode?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<MoneyV2>;
  /** @deprecated Use `compareAtPrice` instead. */
  compareAtPriceV2?: Maybe<MoneyV2>;
  components: ProductVariantComponentConnection;
  currentlyNotInStock: Scalars['Boolean'];
  groupedBy: ProductVariantConnection;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  price: MoneyV2;
  /** @deprecated Use `price` instead. */
  priceV2: MoneyV2;
  product: Product;
  quantityAvailable?: Maybe<Scalars['Int']>;
  quantityPriceBreaks: QuantityPriceBreakConnection;
  quantityRule: QuantityRule;
  requiresComponents: Scalars['Boolean'];
  requiresShipping: Scalars['Boolean'];
  selectedOptions: Array<SelectedOption>;
  sellingPlanAllocations: SellingPlanAllocationConnection;
  shopPayInstallmentsPricing?: Maybe<ShopPayInstallmentsProductVariantPricing>;
  sku?: Maybe<Scalars['String']>;
  storeAvailability: StoreAvailabilityConnection;
  taxable: Scalars['Boolean'];
  title: Scalars['String'];
  unitPrice?: Maybe<MoneyV2>;
  unitPriceMeasurement?: Maybe<UnitPriceMeasurement>;
  weight?: Maybe<Scalars['Float']>;
  weightUnit: WeightUnit;
};


export type ProductVariantComponentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductVariantGroupedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductVariantMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type ProductVariantMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};


export type ProductVariantQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductVariantSellingPlanAllocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type ProductVariantStoreAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  near?: InputMaybe<GeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type ProductVariantComponent = {
  __typename?: 'ProductVariantComponent';
  productVariant: ProductVariant;
  quantity: Scalars['Int'];
};

export type ProductVariantComponentConnection = {
  __typename?: 'ProductVariantComponentConnection';
  edges: Array<ProductVariantComponentEdge>;
  nodes: Array<ProductVariantComponent>;
  pageInfo: PageInfo;
};

export type ProductVariantComponentEdge = {
  __typename?: 'ProductVariantComponentEdge';
  cursor: Scalars['String'];
  node: ProductVariantComponent;
};

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  edges: Array<ProductVariantEdge>;
  nodes: Array<ProductVariant>;
  pageInfo: PageInfo;
};

export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  cursor: Scalars['String'];
  node: ProductVariant;
};

export type ProductVariantSortKeys =
  | 'ID'
  | 'POSITION'
  | 'RELEVANCE'
  | 'SKU'
  | 'TITLE';

export type PurchasingCompany = {
  __typename?: 'PurchasingCompany';
  company: Company;
  contact?: Maybe<CompanyContact>;
  location: CompanyLocation;
};

export type QuantityPriceBreak = {
  __typename?: 'QuantityPriceBreak';
  minimumQuantity: Scalars['Int'];
  price: MoneyV2;
};

export type QuantityPriceBreakConnection = {
  __typename?: 'QuantityPriceBreakConnection';
  edges: Array<QuantityPriceBreakEdge>;
  nodes: Array<QuantityPriceBreak>;
  pageInfo: PageInfo;
};

export type QuantityPriceBreakEdge = {
  __typename?: 'QuantityPriceBreakEdge';
  cursor: Scalars['String'];
  node: QuantityPriceBreak;
};

export type QuantityRule = {
  __typename?: 'QuantityRule';
  increment: Scalars['Int'];
  maximum?: Maybe<Scalars['Int']>;
  minimum: Scalars['Int'];
};

export type QueryRoot = {
  __typename?: 'QueryRoot';
  article?: Maybe<Article>;
  articles: ArticleConnection;
  blog?: Maybe<Blog>;
  /** @deprecated Use `blog` instead. */
  blogByHandle?: Maybe<Blog>;
  blogs: BlogConnection;
  cart?: Maybe<Cart>;
  cartCompletionAttempt?: Maybe<CartCompletionAttemptResult>;
  collection?: Maybe<Collection>;
  /** @deprecated Use `collection` instead. */
  collectionByHandle?: Maybe<Collection>;
  collections: CollectionConnection;
  customer?: Maybe<Customer>;
  localization: Localization;
  locations: LocationConnection;
  menu?: Maybe<Menu>;
  metaobject?: Maybe<Metaobject>;
  metaobjects: MetaobjectConnection;
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  page?: Maybe<Page>;
  /** @deprecated Use `page` instead. */
  pageByHandle?: Maybe<Page>;
  pages: PageConnection;
  paymentSettings: PaymentSettings;
  predictiveSearch?: Maybe<PredictiveSearchResult>;
  product?: Maybe<Product>;
  /** @deprecated Use `product` instead. */
  productByHandle?: Maybe<Product>;
  productRecommendations?: Maybe<Array<Product>>;
  productTags: StringConnection;
  productTypes: StringConnection;
  products: ProductConnection;
  publicApiVersions: Array<ApiVersion>;
  search: SearchResultItemConnection;
  shop: Shop;
  sitemap: Sitemap;
  urlRedirects: UrlRedirectConnection;
};


export type QueryRootArticleArgs = {
  id: Scalars['ID'];
};


export type QueryRootArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ArticleSortKeys>;
};


export type QueryRootBlogArgs = {
  handle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootBlogByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryRootBlogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<BlogSortKeys>;
};


export type QueryRootCartArgs = {
  id: Scalars['ID'];
};


export type QueryRootCartCompletionAttemptArgs = {
  attemptId: Scalars['String'];
};


export type QueryRootCollectionArgs = {
  handle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootCollectionByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryRootCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


export type QueryRootCustomerArgs = {
  customerAccessToken: Scalars['String'];
};


export type QueryRootLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  near?: InputMaybe<GeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};


export type QueryRootMenuArgs = {
  handle: Scalars['String'];
};


export type QueryRootMetaobjectArgs = {
  handle?: InputMaybe<MetaobjectHandleInput>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type QueryRootNodeArgs = {
  id: Scalars['ID'];
};


export type QueryRootNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryRootPageArgs = {
  handle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootPageByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryRootPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<PageSortKeys>;
};


export type QueryRootPredictiveSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  limitScope?: InputMaybe<PredictiveSearchLimitScope>;
  query: Scalars['String'];
  searchableFields?: InputMaybe<Array<SearchableField>>;
  types?: InputMaybe<Array<PredictiveSearchType>>;
  unavailableProducts?: InputMaybe<SearchUnavailableProductsType>;
};


export type QueryRootProductArgs = {
  handle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootProductByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryRootProductRecommendationsArgs = {
  intent?: InputMaybe<ProductRecommendationIntent>;
  productHandle?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootProductTagsArgs = {
  first: Scalars['Int'];
};


export type QueryRootProductTypesArgs = {
  first: Scalars['Int'];
};


export type QueryRootProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


export type QueryRootSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<SearchPrefixQueryType>;
  productFilters?: InputMaybe<Array<ProductFilter>>;
  query: Scalars['String'];
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SearchSortKeys>;
  types?: InputMaybe<Array<SearchType>>;
  unavailableProducts?: InputMaybe<SearchUnavailableProductsType>;
};


export type QueryRootSitemapArgs = {
  type: SitemapType;
};


export type QueryRootUrlRedirectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type Seo = {
  __typename?: 'SEO';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ScriptDiscountApplication = DiscountApplication & {
  __typename?: 'ScriptDiscountApplication';
  allocationMethod: DiscountApplicationAllocationMethod;
  targetSelection: DiscountApplicationTargetSelection;
  targetType: DiscountApplicationTargetType;
  title: Scalars['String'];
  value: PricingValue;
};

export type SearchPrefixQueryType =
  | 'LAST'
  | 'NONE';

export type SearchQuerySuggestion = Trackable & {
  __typename?: 'SearchQuerySuggestion';
  styledText: Scalars['String'];
  text: Scalars['String'];
  trackingParameters?: Maybe<Scalars['String']>;
};

export type SearchResultItem = Article | Page | Product;

export type SearchResultItemConnection = {
  __typename?: 'SearchResultItemConnection';
  edges: Array<SearchResultItemEdge>;
  nodes: Array<SearchResultItem>;
  pageInfo: PageInfo;
  productFilters: Array<Filter>;
  totalCount: Scalars['Int'];
};

export type SearchResultItemEdge = {
  __typename?: 'SearchResultItemEdge';
  cursor: Scalars['String'];
  node: SearchResultItem;
};

export type SearchSortKeys =
  | 'PRICE'
  | 'RELEVANCE';

export type SearchType =
  | 'ARTICLE'
  | 'PAGE'
  | 'PRODUCT';

export type SearchUnavailableProductsType =
  | 'HIDE'
  | 'LAST'
  | 'SHOW';

export type SearchableField =
  | 'AUTHOR'
  | 'BODY'
  | 'PRODUCT_TYPE'
  | 'TAG'
  | 'TITLE'
  | 'VARIANTS_BARCODE'
  | 'VARIANTS_SKU'
  | 'VARIANTS_TITLE'
  | 'VENDOR';

export type SelectedOption = {
  __typename?: 'SelectedOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SelectedOptionInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SellingPlan = HasMetafields & {
  __typename?: 'SellingPlan';
  billingPolicy?: Maybe<SellingPlanBillingPolicy>;
  checkoutCharge: SellingPlanCheckoutCharge;
  deliveryPolicy?: Maybe<SellingPlanDeliveryPolicy>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  name: Scalars['String'];
  options: Array<SellingPlanOption>;
  priceAdjustments: Array<SellingPlanPriceAdjustment>;
  recurringDeliveries: Scalars['Boolean'];
};


export type SellingPlanMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type SellingPlanMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type SellingPlanAllocation = {
  __typename?: 'SellingPlanAllocation';
  checkoutChargeAmount: MoneyV2;
  priceAdjustments: Array<SellingPlanAllocationPriceAdjustment>;
  remainingBalanceChargeAmount: MoneyV2;
  sellingPlan: SellingPlan;
};

export type SellingPlanAllocationConnection = {
  __typename?: 'SellingPlanAllocationConnection';
  edges: Array<SellingPlanAllocationEdge>;
  nodes: Array<SellingPlanAllocation>;
  pageInfo: PageInfo;
};

export type SellingPlanAllocationEdge = {
  __typename?: 'SellingPlanAllocationEdge';
  cursor: Scalars['String'];
  node: SellingPlanAllocation;
};

export type SellingPlanAllocationPriceAdjustment = {
  __typename?: 'SellingPlanAllocationPriceAdjustment';
  compareAtPrice: MoneyV2;
  perDeliveryPrice: MoneyV2;
  price: MoneyV2;
  unitPrice?: Maybe<MoneyV2>;
};

export type SellingPlanBillingPolicy = SellingPlanRecurringBillingPolicy;

export type SellingPlanCheckoutCharge = {
  __typename?: 'SellingPlanCheckoutCharge';
  type: SellingPlanCheckoutChargeType;
  value: SellingPlanCheckoutChargeValue;
};

export type SellingPlanCheckoutChargePercentageValue = {
  __typename?: 'SellingPlanCheckoutChargePercentageValue';
  percentage: Scalars['Float'];
};

export type SellingPlanCheckoutChargeType =
  | 'PERCENTAGE'
  | 'PRICE';

export type SellingPlanCheckoutChargeValue = MoneyV2 | SellingPlanCheckoutChargePercentageValue;

export type SellingPlanConnection = {
  __typename?: 'SellingPlanConnection';
  edges: Array<SellingPlanEdge>;
  nodes: Array<SellingPlan>;
  pageInfo: PageInfo;
};

export type SellingPlanDeliveryPolicy = SellingPlanRecurringDeliveryPolicy;

export type SellingPlanEdge = {
  __typename?: 'SellingPlanEdge';
  cursor: Scalars['String'];
  node: SellingPlan;
};

export type SellingPlanFixedAmountPriceAdjustment = {
  __typename?: 'SellingPlanFixedAmountPriceAdjustment';
  adjustmentAmount: MoneyV2;
};

export type SellingPlanFixedPriceAdjustment = {
  __typename?: 'SellingPlanFixedPriceAdjustment';
  price: MoneyV2;
};

export type SellingPlanGroup = {
  __typename?: 'SellingPlanGroup';
  appName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options: Array<SellingPlanGroupOption>;
  sellingPlans: SellingPlanConnection;
};


export type SellingPlanGroupSellingPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type SellingPlanGroupConnection = {
  __typename?: 'SellingPlanGroupConnection';
  edges: Array<SellingPlanGroupEdge>;
  nodes: Array<SellingPlanGroup>;
  pageInfo: PageInfo;
};

export type SellingPlanGroupEdge = {
  __typename?: 'SellingPlanGroupEdge';
  cursor: Scalars['String'];
  node: SellingPlanGroup;
};

export type SellingPlanGroupOption = {
  __typename?: 'SellingPlanGroupOption';
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type SellingPlanInterval =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

export type SellingPlanOption = {
  __typename?: 'SellingPlanOption';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SellingPlanPercentagePriceAdjustment = {
  __typename?: 'SellingPlanPercentagePriceAdjustment';
  adjustmentPercentage: Scalars['Float'];
};

export type SellingPlanPriceAdjustment = {
  __typename?: 'SellingPlanPriceAdjustment';
  adjustmentValue: SellingPlanPriceAdjustmentValue;
  orderCount?: Maybe<Scalars['Int']>;
};

export type SellingPlanPriceAdjustmentValue = SellingPlanFixedAmountPriceAdjustment | SellingPlanFixedPriceAdjustment | SellingPlanPercentagePriceAdjustment;

export type SellingPlanRecurringBillingPolicy = {
  __typename?: 'SellingPlanRecurringBillingPolicy';
  interval: SellingPlanInterval;
  intervalCount: Scalars['Int'];
};

export type SellingPlanRecurringDeliveryPolicy = {
  __typename?: 'SellingPlanRecurringDeliveryPolicy';
  interval: SellingPlanInterval;
  intervalCount: Scalars['Int'];
};

export type Shop = HasMetafields & Node & {
  __typename?: 'Shop';
  brand?: Maybe<Brand>;
  contactInformation?: Maybe<ShopPolicy>;
  customerAccountTranslations?: Maybe<Array<Translation>>;
  customerAccountUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalNotice?: Maybe<ShopPolicy>;
  metafield?: Maybe<Metafield>;
  metafields: Array<Maybe<Metafield>>;
  moneyFormat: Scalars['String'];
  name: Scalars['String'];
  paymentSettings: PaymentSettings;
  primaryDomain: Domain;
  privacyPolicy?: Maybe<ShopPolicy>;
  refundPolicy?: Maybe<ShopPolicy>;
  shippingPolicy?: Maybe<ShopPolicy>;
  shipsToCountries: Array<CountryCode>;
  shopPayInstallmentsPricing?: Maybe<ShopPayInstallmentsPricing>;
  socialLoginProviders: Array<SocialLoginProvider>;
  subscriptionPolicy?: Maybe<ShopPolicyWithDefault>;
  termsOfSale?: Maybe<ShopPolicy>;
  termsOfService?: Maybe<ShopPolicy>;
};


export type ShopMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


export type ShopMetafieldsArgs = {
  identifiers: Array<HasMetafieldsIdentifier>;
};

export type ShopPayInstallmentsFinancingPlan = Node & {
  __typename?: 'ShopPayInstallmentsFinancingPlan';
  id: Scalars['ID'];
  maxPrice: MoneyV2;
  minPrice: MoneyV2;
  terms: Array<ShopPayInstallmentsFinancingPlanTerm>;
};

export type ShopPayInstallmentsFinancingPlanFrequency =
  | 'MONTHLY'
  | 'WEEKLY';

export type ShopPayInstallmentsFinancingPlanTerm = Node & {
  __typename?: 'ShopPayInstallmentsFinancingPlanTerm';
  apr: Scalars['Int'];
  frequency: ShopPayInstallmentsFinancingPlanFrequency;
  id: Scalars['ID'];
  installmentsCount?: Maybe<Count>;
  loanType: ShopPayInstallmentsLoan;
};

export type ShopPayInstallmentsLoan =
  | 'INTEREST'
  | 'SPLIT_PAY'
  | 'ZERO_PERCENT';

export type ShopPayInstallmentsPricing = {
  __typename?: 'ShopPayInstallmentsPricing';
  financingPlans: Array<ShopPayInstallmentsFinancingPlan>;
  maxPrice: MoneyV2;
  minPrice: MoneyV2;
};

export type ShopPayInstallmentsProductVariantPricing = Node & {
  __typename?: 'ShopPayInstallmentsProductVariantPricing';
  available: Scalars['Boolean'];
  eligible: Scalars['Boolean'];
  fullPrice: MoneyV2;
  id: Scalars['ID'];
  installmentsCount?: Maybe<Count>;
  pricePerTerm: MoneyV2;
};

export type ShopPayPaymentRequest = {
  __typename?: 'ShopPayPaymentRequest';
  /** @deprecated This field is deprecated and will be removed in a future version. */
  deliveryMethods: Array<ShopPayPaymentRequestDeliveryMethod>;
  discountCodes: Array<Scalars['String']>;
  discounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  lineItems: Array<ShopPayPaymentRequestLineItem>;
  locale: Scalars['String'];
  presentmentCurrency: CurrencyCode;
  selectedDeliveryMethodType: ShopPayPaymentRequestDeliveryMethodType;
  shippingAddress?: Maybe<ShopPayPaymentRequestContactField>;
  shippingLines: Array<ShopPayPaymentRequestShippingLine>;
  subtotal: MoneyV2;
  total: MoneyV2;
  totalShippingPrice?: Maybe<ShopPayPaymentRequestTotalShippingPrice>;
  totalTax?: Maybe<MoneyV2>;
};

export type ShopPayPaymentRequestContactField = {
  __typename?: 'ShopPayPaymentRequestContactField';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
};

export type ShopPayPaymentRequestDeliveryMethod = {
  __typename?: 'ShopPayPaymentRequestDeliveryMethod';
  amount: MoneyV2;
  code: Scalars['String'];
  deliveryExpectationLabel?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  maxDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  minDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ShopPayPaymentRequestDeliveryMethodInput = {
  amount?: InputMaybe<MoneyInput>;
  code?: InputMaybe<Scalars['String']>;
  deliveryExpectationLabel?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  maxDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  minDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type ShopPayPaymentRequestDeliveryMethodType =
  | 'PICKUP'
  | 'SHIPPING';

export type ShopPayPaymentRequestDiscount = {
  __typename?: 'ShopPayPaymentRequestDiscount';
  amount: MoneyV2;
  label: Scalars['String'];
};

export type ShopPayPaymentRequestDiscountInput = {
  amount?: InputMaybe<MoneyInput>;
  label?: InputMaybe<Scalars['String']>;
};

export type ShopPayPaymentRequestImage = {
  __typename?: 'ShopPayPaymentRequestImage';
  alt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ShopPayPaymentRequestImageInput = {
  alt?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ShopPayPaymentRequestInput = {
  discountCodes?: InputMaybe<Array<Scalars['String']>>;
  discounts?: InputMaybe<Array<ShopPayPaymentRequestDiscountInput>>;
  lineItems?: InputMaybe<Array<ShopPayPaymentRequestLineItemInput>>;
  locale: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  presentmentCurrency: CurrencyCode;
  selectedDeliveryMethodType?: InputMaybe<ShopPayPaymentRequestDeliveryMethodType>;
  shippingLines?: InputMaybe<Array<ShopPayPaymentRequestShippingLineInput>>;
  subtotal: MoneyInput;
  total: MoneyInput;
  totalShippingPrice?: InputMaybe<ShopPayPaymentRequestTotalShippingPriceInput>;
  totalTax?: InputMaybe<MoneyInput>;
};

export type ShopPayPaymentRequestLineItem = {
  __typename?: 'ShopPayPaymentRequestLineItem';
  finalItemPrice: MoneyV2;
  finalLinePrice: MoneyV2;
  image?: Maybe<ShopPayPaymentRequestImage>;
  itemDiscounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  label: Scalars['String'];
  lineDiscounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  originalItemPrice?: Maybe<MoneyV2>;
  originalLinePrice?: Maybe<MoneyV2>;
  quantity: Scalars['Int'];
  requiresShipping?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
};

export type ShopPayPaymentRequestLineItemInput = {
  finalItemPrice?: InputMaybe<MoneyInput>;
  finalLinePrice?: InputMaybe<MoneyInput>;
  image?: InputMaybe<ShopPayPaymentRequestImageInput>;
  itemDiscounts?: InputMaybe<Array<ShopPayPaymentRequestDiscountInput>>;
  label?: InputMaybe<Scalars['String']>;
  lineDiscounts?: InputMaybe<Array<ShopPayPaymentRequestDiscountInput>>;
  originalItemPrice?: InputMaybe<MoneyInput>;
  originalLinePrice?: InputMaybe<MoneyInput>;
  quantity: Scalars['Int'];
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type ShopPayPaymentRequestReceipt = {
  __typename?: 'ShopPayPaymentRequestReceipt';
  paymentRequest: ShopPayPaymentRequest;
  processingStatusType: Scalars['String'];
  token: Scalars['String'];
};

export type ShopPayPaymentRequestSession = {
  __typename?: 'ShopPayPaymentRequestSession';
  checkoutUrl: Scalars['URL'];
  paymentRequest: ShopPayPaymentRequest;
  sourceIdentifier: Scalars['String'];
  token: Scalars['String'];
};

export type ShopPayPaymentRequestSessionCreatePayload = {
  __typename?: 'ShopPayPaymentRequestSessionCreatePayload';
  shopPayPaymentRequestSession?: Maybe<ShopPayPaymentRequestSession>;
  userErrors: Array<UserErrorsShopPayPaymentRequestSessionUserErrors>;
};

export type ShopPayPaymentRequestSessionSubmitPayload = {
  __typename?: 'ShopPayPaymentRequestSessionSubmitPayload';
  paymentRequestReceipt?: Maybe<ShopPayPaymentRequestReceipt>;
  userErrors: Array<UserErrorsShopPayPaymentRequestSessionUserErrors>;
};

export type ShopPayPaymentRequestShippingLine = {
  __typename?: 'ShopPayPaymentRequestShippingLine';
  amount: MoneyV2;
  code: Scalars['String'];
  label: Scalars['String'];
};

export type ShopPayPaymentRequestShippingLineInput = {
  amount?: InputMaybe<MoneyInput>;
  code?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type ShopPayPaymentRequestTotalShippingPrice = {
  __typename?: 'ShopPayPaymentRequestTotalShippingPrice';
  discounts: Array<ShopPayPaymentRequestDiscount>;
  finalTotal: MoneyV2;
  originalTotal?: Maybe<MoneyV2>;
};

export type ShopPayPaymentRequestTotalShippingPriceInput = {
  discounts?: InputMaybe<Array<ShopPayPaymentRequestDiscountInput>>;
  finalTotal?: InputMaybe<MoneyInput>;
  originalTotal?: InputMaybe<MoneyInput>;
};

export type ShopPayWalletContentInput = {
  billingAddress: MailingAddressInput;
  sessionToken: Scalars['String'];
};

export type ShopPolicy = Node & {
  __typename?: 'ShopPolicy';
  body: Scalars['String'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['URL'];
};

export type ShopPolicyWithDefault = {
  __typename?: 'ShopPolicyWithDefault';
  body: Scalars['String'];
  handle: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  url: Scalars['URL'];
};

export type Sitemap = {
  __typename?: 'Sitemap';
  pagesCount?: Maybe<Count>;
  resources?: Maybe<PaginatedSitemapResources>;
};


export type SitemapResourcesArgs = {
  page: Scalars['Int'];
};

export type SitemapImage = {
  __typename?: 'SitemapImage';
  alt?: Maybe<Scalars['String']>;
  filepath?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SitemapResource = SitemapResourceInterface & {
  __typename?: 'SitemapResource';
  handle: Scalars['String'];
  image?: Maybe<SitemapImage>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SitemapResourceInterface = {
  handle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SitemapResourceMetaobject = SitemapResourceInterface & {
  __typename?: 'SitemapResourceMetaobject';
  handle: Scalars['String'];
  onlineStoreUrlHandle?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SitemapType =
  | 'ARTICLE'
  | 'BLOG'
  | 'COLLECTION'
  | 'METAOBJECT'
  | 'PAGE'
  | 'PRODUCT';

export type SocialLoginProvider = {
  __typename?: 'SocialLoginProvider';
  handle: Scalars['String'];
};

export type StoreAvailability = {
  __typename?: 'StoreAvailability';
  available: Scalars['Boolean'];
  location: Location;
  pickUpTime: Scalars['String'];
  quantityAvailable: Scalars['Int'];
};

export type StoreAvailabilityConnection = {
  __typename?: 'StoreAvailabilityConnection';
  edges: Array<StoreAvailabilityEdge>;
  nodes: Array<StoreAvailability>;
  pageInfo: PageInfo;
};

export type StoreAvailabilityEdge = {
  __typename?: 'StoreAvailabilityEdge';
  cursor: Scalars['String'];
  node: StoreAvailability;
};

export type StringConnection = {
  __typename?: 'StringConnection';
  edges: Array<StringEdge>;
  nodes: Array<Scalars['String']>;
  pageInfo: PageInfo;
};

export type StringEdge = {
  __typename?: 'StringEdge';
  cursor: Scalars['String'];
  node: Scalars['String'];
};

export type SubmissionError = {
  __typename?: 'SubmissionError';
  code: SubmissionErrorCode;
  message?: Maybe<Scalars['String']>;
};

export type SubmissionErrorCode =
  | 'BUYER_IDENTITY_EMAIL_IS_INVALID'
  | 'BUYER_IDENTITY_EMAIL_REQUIRED'
  | 'BUYER_IDENTITY_PHONE_IS_INVALID'
  | 'DELIVERY_ADDRESS1_INVALID'
  | 'DELIVERY_ADDRESS1_REQUIRED'
  | 'DELIVERY_ADDRESS1_TOO_LONG'
  | 'DELIVERY_ADDRESS2_INVALID'
  | 'DELIVERY_ADDRESS2_REQUIRED'
  | 'DELIVERY_ADDRESS2_TOO_LONG'
  | 'DELIVERY_ADDRESS_REQUIRED'
  | 'DELIVERY_CITY_INVALID'
  | 'DELIVERY_CITY_REQUIRED'
  | 'DELIVERY_CITY_TOO_LONG'
  | 'DELIVERY_COMPANY_INVALID'
  | 'DELIVERY_COMPANY_REQUIRED'
  | 'DELIVERY_COMPANY_TOO_LONG'
  | 'DELIVERY_COUNTRY_REQUIRED'
  | 'DELIVERY_FIRST_NAME_INVALID'
  | 'DELIVERY_FIRST_NAME_REQUIRED'
  | 'DELIVERY_FIRST_NAME_TOO_LONG'
  | 'DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY'
  | 'DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE'
  | 'DELIVERY_LAST_NAME_INVALID'
  | 'DELIVERY_LAST_NAME_REQUIRED'
  | 'DELIVERY_LAST_NAME_TOO_LONG'
  | 'DELIVERY_NO_DELIVERY_AVAILABLE'
  | 'DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE'
  | 'DELIVERY_OPTIONS_PHONE_NUMBER_INVALID'
  | 'DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED'
  | 'DELIVERY_PHONE_NUMBER_INVALID'
  | 'DELIVERY_PHONE_NUMBER_REQUIRED'
  | 'DELIVERY_POSTAL_CODE_INVALID'
  | 'DELIVERY_POSTAL_CODE_REQUIRED'
  | 'DELIVERY_ZONE_NOT_FOUND'
  | 'DELIVERY_ZONE_REQUIRED_FOR_COUNTRY'
  | 'ERROR'
  | 'MERCHANDISE_LINE_LIMIT_REACHED'
  | 'MERCHANDISE_NOT_APPLICABLE'
  | 'MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE'
  | 'MERCHANDISE_OUT_OF_STOCK'
  | 'MERCHANDISE_PRODUCT_NOT_PUBLISHED'
  | 'NO_DELIVERY_GROUP_SELECTED'
  | 'PAYMENTS_ADDRESS1_INVALID'
  | 'PAYMENTS_ADDRESS1_REQUIRED'
  | 'PAYMENTS_ADDRESS1_TOO_LONG'
  | 'PAYMENTS_ADDRESS2_INVALID'
  | 'PAYMENTS_ADDRESS2_REQUIRED'
  | 'PAYMENTS_ADDRESS2_TOO_LONG'
  | 'PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND'
  | 'PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY'
  | 'PAYMENTS_CITY_INVALID'
  | 'PAYMENTS_CITY_REQUIRED'
  | 'PAYMENTS_CITY_TOO_LONG'
  | 'PAYMENTS_COMPANY_INVALID'
  | 'PAYMENTS_COMPANY_REQUIRED'
  | 'PAYMENTS_COMPANY_TOO_LONG'
  | 'PAYMENTS_COUNTRY_REQUIRED'
  | 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED'
  | 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED'
  | 'PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT'
  | 'PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED'
  | 'PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK'
  | 'PAYMENTS_CREDIT_CARD_GENERIC'
  | 'PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK'
  | 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION'
  | 'PAYMENTS_CREDIT_CARD_NAME_INVALID'
  | 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID'
  | 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT'
  | 'PAYMENTS_CREDIT_CARD_SESSION_ID'
  | 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK'
  | 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE'
  | 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED'
  | 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR'
  | 'PAYMENTS_FIRST_NAME_INVALID'
  | 'PAYMENTS_FIRST_NAME_REQUIRED'
  | 'PAYMENTS_FIRST_NAME_TOO_LONG'
  | 'PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY'
  | 'PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE'
  | 'PAYMENTS_LAST_NAME_INVALID'
  | 'PAYMENTS_LAST_NAME_REQUIRED'
  | 'PAYMENTS_LAST_NAME_TOO_LONG'
  | 'PAYMENTS_METHOD_REQUIRED'
  | 'PAYMENTS_METHOD_UNAVAILABLE'
  | 'PAYMENTS_PHONE_NUMBER_INVALID'
  | 'PAYMENTS_PHONE_NUMBER_REQUIRED'
  | 'PAYMENTS_POSTAL_CODE_INVALID'
  | 'PAYMENTS_POSTAL_CODE_REQUIRED'
  | 'PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED'
  | 'PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT'
  | 'PAYMENTS_WALLET_CONTENT_MISSING'
  | 'REDIRECT_TO_CHECKOUT_REQUIRED'
  | 'TAXES_DELIVERY_GROUP_ID_NOT_FOUND'
  | 'TAXES_LINE_ID_NOT_FOUND'
  | 'TAXES_MUST_BE_DEFINED'
  | 'VALIDATION_CUSTOM';

export type SubmitAlreadyAccepted = {
  __typename?: 'SubmitAlreadyAccepted';
  attemptId: Scalars['String'];
};

export type SubmitFailed = {
  __typename?: 'SubmitFailed';
  checkoutUrl?: Maybe<Scalars['URL']>;
  errors: Array<SubmissionError>;
};

export type SubmitSuccess = {
  __typename?: 'SubmitSuccess';
  attemptId: Scalars['String'];
  redirectUrl: Scalars['URL'];
};

export type SubmitThrottled = {
  __typename?: 'SubmitThrottled';
  pollAfter: Scalars['DateTime'];
};

export type Swatch = {
  __typename?: 'Swatch';
  color?: Maybe<Scalars['Color']>;
  image?: Maybe<MediaImage>;
};

export type TaxonomyCategory = Node & {
  __typename?: 'TaxonomyCategory';
  ancestors: Array<TaxonomyCategory>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TaxonomyMetafieldFilter = {
  key: Scalars['String'];
  namespace: Scalars['String'];
  value: Scalars['String'];
};

export type Trackable = {
  trackingParameters?: Maybe<Scalars['String']>;
};

export type Translation = {
  __typename?: 'Translation';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UnitPriceMeasurement = {
  __typename?: 'UnitPriceMeasurement';
  measuredType?: Maybe<UnitPriceMeasurementMeasuredType>;
  quantityUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  quantityValue: Scalars['Float'];
  referenceUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  referenceValue: Scalars['Int'];
};

export type UnitPriceMeasurementMeasuredType =
  | 'AREA'
  | 'COUNT'
  | 'LENGTH'
  | 'UNKNOWN'
  | 'VOLUME'
  | 'WEIGHT';

export type UnitPriceMeasurementMeasuredUnit =
  | 'CL'
  | 'CM'
  | 'FLOZ'
  | 'FT'
  | 'FT2'
  | 'G'
  | 'GAL'
  | 'IN'
  | 'ITEM'
  | 'KG'
  | 'L'
  | 'LB'
  | 'M'
  | 'M2'
  | 'M3'
  | 'MG'
  | 'ML'
  | 'MM'
  | 'OZ'
  | 'PT'
  | 'QT'
  | 'UNKNOWN'
  | 'YD';

export type UnitSystem =
  | 'IMPERIAL_SYSTEM'
  | 'METRIC_SYSTEM';

export type UrlRedirect = Node & {
  __typename?: 'UrlRedirect';
  id: Scalars['ID'];
  path: Scalars['String'];
  target: Scalars['String'];
};

export type UrlRedirectConnection = {
  __typename?: 'UrlRedirectConnection';
  edges: Array<UrlRedirectEdge>;
  nodes: Array<UrlRedirect>;
  pageInfo: PageInfo;
};

export type UrlRedirectEdge = {
  __typename?: 'UrlRedirectEdge';
  cursor: Scalars['String'];
  node: UrlRedirect;
};

export type UserError = DisplayableError & {
  __typename?: 'UserError';
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type UserErrorsShopPayPaymentRequestSessionUserErrors = DisplayableError & {
  __typename?: 'UserErrorsShopPayPaymentRequestSessionUserErrors';
  code?: Maybe<UserErrorsShopPayPaymentRequestSessionUserErrorsCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type UserErrorsShopPayPaymentRequestSessionUserErrorsCode =
  | 'IDEMPOTENCY_KEY_ALREADY_USED'
  | 'PAYMENT_REQUEST_INVALID_INPUT'
  | 'PAYMENT_REQUEST_NOT_FOUND';

export type VariantOptionFilter = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Video = Media & Node & {
  __typename?: 'Video';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaContentType: MediaContentType;
  presentation?: Maybe<MediaPresentation>;
  previewImage?: Maybe<Image>;
  sources: Array<VideoSource>;
};

export type VideoSource = {
  __typename?: 'VideoSource';
  format: Scalars['String'];
  height: Scalars['Int'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type VisitorConsent = {
  analytics?: InputMaybe<Scalars['Boolean']>;
  marketing?: InputMaybe<Scalars['Boolean']>;
  preferences?: InputMaybe<Scalars['Boolean']>;
  saleOfData?: InputMaybe<Scalars['Boolean']>;
};

export type WeightUnit =
  | 'GRAMS'
  | 'KILOGRAMS'
  | 'OUNCES'
  | 'POUNDS';

export type AddCartLinesMutationVariables = Exact<{
  cartId: Scalars['ID'];
  lines: Array<CartLineInput> | CartLineInput;
  country: CountryCode;
  language: LanguageCode;
}>;


export type AddCartLinesMutation = { __typename?: 'Mutation', cartLinesAdd?: { __typename?: 'CartLinesAddPayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string, target: string }> } | null };

export type CartFieldsFragment = { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } };

export type CreateCartMutationVariables = Exact<{
  input: CartInput;
  country: CountryCode;
  language: LanguageCode;
}>;


export type CreateCartMutation = { __typename?: 'Mutation', cartCreate?: { __typename?: 'CartCreatePayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type GetCartQueryVariables = Exact<{
  cartId: Scalars['ID'];
  country: CountryCode;
  language: LanguageCode;
}>;


export type GetCartQuery = { __typename?: 'QueryRoot', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null };

export type RemoveCartLinesMutationVariables = Exact<{
  cartId: Scalars['ID'];
  lineIds: Array<Scalars['ID']> | Scalars['ID'];
  country: CountryCode;
  language: LanguageCode;
}>;


export type RemoveCartLinesMutation = { __typename?: 'Mutation', cartLinesRemove?: { __typename?: 'CartLinesRemovePayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string, target: string }> } | null };

export type UpdateCartAttributesMutationVariables = Exact<{
  attributes: Array<AttributeInput> | AttributeInput;
  cartId: Scalars['ID'];
  country: CountryCode;
  language: LanguageCode;
}>;


export type UpdateCartAttributesMutation = { __typename?: 'Mutation', cartAttributesUpdate?: { __typename?: 'CartAttributesUpdatePayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string, target: string }> } | null };

export type UpdateCartBuyerIdentityMutationVariables = Exact<{
  buyerIdentity: CartBuyerIdentityInput;
  cartId: Scalars['ID'];
  country: CountryCode;
  language: LanguageCode;
}>;


export type UpdateCartBuyerIdentityMutation = { __typename?: 'Mutation', cartBuyerIdentityUpdate?: { __typename?: 'CartBuyerIdentityUpdatePayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string, target: string }> } | null };

export type UpdateCartLinesMutationVariables = Exact<{
  cartId: Scalars['ID'];
  lines: Array<CartLineUpdateInput> | CartLineUpdateInput;
  country: CountryCode;
  language: LanguageCode;
}>;


export type UpdateCartLinesMutation = { __typename?: 'Mutation', cartLinesUpdate?: { __typename?: 'CartLinesUpdatePayload', cart?: { __typename?: 'Cart', id: string, checkoutUrl: string, totalQuantity: number, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, buyerIdentity: { __typename?: 'CartBuyerIdentity', customer?: { __typename?: 'Customer', id: string } | null }, cost: { __typename?: 'CartCost', subtotalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'CartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } | { __typename?: 'ComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'CartLineCost', amountPerQuantity: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } | null, totalAmount: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode } }, merchandise: { __typename?: 'ProductVariant', id: string, quantityAvailable?: number | null, requiresShipping: boolean, sku?: string | null, title: string, image?: { __typename?: 'Image', url: string } | null, metafieldInternalDisplayName?: { __typename?: 'Metafield', value: string } | null, metafieldAnalyticsDimensions?: { __typename?: 'Metafield', value: string } | null, metafieldBackordered?: { __typename?: 'Metafield', value: string } | null, metafieldPreorder?: { __typename?: 'Metafield', value: string } | null, price: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, product: { __typename?: 'Product', id: string, handle: string, tags: Array<string>, title: string, metafieldOemPartnership?: { __typename?: 'Metafield', value: string } | null } } } }> } } | null, userErrors: Array<{ __typename?: 'CartUserError', code?: CartErrorCode | null, field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string, target: string }> } | null };

export type CreateCustomerAccessTokenWithMultipassMutationVariables = Exact<{
  multipassToken: Scalars['String'];
}>;


export type CreateCustomerAccessTokenWithMultipassMutation = { __typename?: 'Mutation', customerAccessTokenCreateWithMultipass?: { __typename?: 'CustomerAccessTokenCreateWithMultipassPayload', customerAccessToken?: { __typename?: 'CustomerAccessToken', accessToken: string, expiresAt: string } | null, customerUserErrors: Array<{ __typename?: 'CustomerUserError', code?: CustomerErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type GetCustomerOrdersQueryVariables = Exact<{
  customerAccessToken: Scalars['String'];
}>;


export type GetCustomerOrdersQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', orders: { __typename?: 'OrderConnection', nodes: Array<{ __typename?: 'Order', name: string, processedAt: string, totalPrice: { __typename?: 'MoneyV2', amount: string, currencyCode: CurrencyCode }, lineItems: { __typename?: 'OrderLineItemConnection', nodes: Array<{ __typename?: 'OrderLineItem', title: string, quantity: number, variant?: { __typename?: 'ProductVariant', sku?: string | null, image?: { __typename?: 'Image', url: string } | null } | null }> } }> } } | null };

export const CartFieldsFragmentDoc = `
    fragment CartFields on Cart {
  id
  attributes {
    key
    value
  }
  buyerIdentity {
    customer {
      id
    }
  }
  checkoutUrl
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
  }
  lines(first: 250) {
    edges {
      node {
        id
        cost {
          amountPerQuantity {
            amount
            currencyCode
          }
          compareAtAmountPerQuantity {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }
        }
        merchandise {
          ... on ProductVariant {
            id
            image {
              url
            }
            metafieldInternalDisplayName: metafield(
              namespace: "ifixit"
              key: "internal_display_name"
            ) {
              value
            }
            metafieldAnalyticsDimensions: metafield(
              namespace: "ifixit"
              key: "analytics_dimensions"
            ) {
              value
            }
            metafieldBackordered: metafield(namespace: "ifixit", key: "backordered") {
              value
            }
            metafieldPreorder: metafield(namespace: "ifixit", key: "preorder") {
              value
            }
            price {
              amount
              currencyCode
            }
            product {
              id
              handle
              tags
              title
              metafieldOemPartnership: metafield(
                namespace: "ifixit"
                key: "oem_partnership_json"
              ) {
                value
              }
            }
            quantityAvailable
            requiresShipping
            sku
            title
          }
        }
        quantity
      }
    }
  }
  totalQuantity
}
    `;
export const AddCartLinesDocument = `
    mutation addCartLines($cartId: ID!, $lines: [CartLineInput!]!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const CreateCartDocument = `
    mutation createCart($input: CartInput!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartCreate(input: $input) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const GetCartDocument = `
    query getCart($cartId: ID!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cart(id: $cartId) {
    ...CartFields
  }
}
    ${CartFieldsFragmentDoc}`;
export const RemoveCartLinesDocument = `
    mutation removeCartLines($cartId: ID!, $lineIds: [ID!]!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const UpdateCartAttributesDocument = `
    mutation updateCartAttributes($attributes: [AttributeInput!]!, $cartId: ID!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const UpdateCartBuyerIdentityDocument = `
    mutation updateCartBuyerIdentity($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const UpdateCartLinesDocument = `
    mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ...CartFields
    }
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export const CreateCustomerAccessTokenWithMultipassDocument = `
    mutation createCustomerAccessTokenWithMultipass($multipassToken: String!) {
  customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
    customerAccessToken {
      accessToken
      expiresAt
    }
    customerUserErrors {
      code
      field
      message
    }
  }
}
    `;
export const GetCustomerOrdersDocument = `
    query getCustomerOrders($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    orders(first: 50, sortKey: PROCESSED_AT, reverse: true) {
      nodes {
        name
        processedAt
        totalPrice {
          amount
          currencyCode
        }
        lineItems(first: 100) {
          nodes {
            title
            quantity
            variant {
              sku
              image {
                url(transform: {maxHeight: 80})
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(doc: string, vars?: V, options?: C) => Promise<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    addCartLines(variables: AddCartLinesMutationVariables, options?: C): Promise<AddCartLinesMutation> {
      return requester<AddCartLinesMutation, AddCartLinesMutationVariables>(AddCartLinesDocument, variables, options);
    },
    createCart(variables: CreateCartMutationVariables, options?: C): Promise<CreateCartMutation> {
      return requester<CreateCartMutation, CreateCartMutationVariables>(CreateCartDocument, variables, options);
    },
    getCart(variables: GetCartQueryVariables, options?: C): Promise<GetCartQuery> {
      return requester<GetCartQuery, GetCartQueryVariables>(GetCartDocument, variables, options);
    },
    removeCartLines(variables: RemoveCartLinesMutationVariables, options?: C): Promise<RemoveCartLinesMutation> {
      return requester<RemoveCartLinesMutation, RemoveCartLinesMutationVariables>(RemoveCartLinesDocument, variables, options);
    },
    updateCartAttributes(variables: UpdateCartAttributesMutationVariables, options?: C): Promise<UpdateCartAttributesMutation> {
      return requester<UpdateCartAttributesMutation, UpdateCartAttributesMutationVariables>(UpdateCartAttributesDocument, variables, options);
    },
    updateCartBuyerIdentity(variables: UpdateCartBuyerIdentityMutationVariables, options?: C): Promise<UpdateCartBuyerIdentityMutation> {
      return requester<UpdateCartBuyerIdentityMutation, UpdateCartBuyerIdentityMutationVariables>(UpdateCartBuyerIdentityDocument, variables, options);
    },
    updateCartLines(variables: UpdateCartLinesMutationVariables, options?: C): Promise<UpdateCartLinesMutation> {
      return requester<UpdateCartLinesMutation, UpdateCartLinesMutationVariables>(UpdateCartLinesDocument, variables, options);
    },
    createCustomerAccessTokenWithMultipass(variables: CreateCustomerAccessTokenWithMultipassMutationVariables, options?: C): Promise<CreateCustomerAccessTokenWithMultipassMutation> {
      return requester<CreateCustomerAccessTokenWithMultipassMutation, CreateCustomerAccessTokenWithMultipassMutationVariables>(CreateCustomerAccessTokenWithMultipassDocument, variables, options);
    },
    getCustomerOrders(variables: GetCustomerOrdersQueryVariables, options?: C): Promise<GetCustomerOrdersQuery> {
      return requester<GetCustomerOrdersQuery, GetCustomerOrdersQueryVariables>(GetCustomerOrdersDocument, variables, options);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;